$(document).ready(function() {
'use strict';

$('.order--container').on('click', function () {
  if ($(this).hasClass('follow__link') == false) {
    var orderId = $(this).attr('order-id');
    $('.order__details[order-id="' + orderId + '"]').slideToggle(200).toggleClass('is-active');
    $(this).toggleClass('child-active');
    $(this).children('.open__line__items--link').children().toggleClass('arrow--top arrow--bottom');
  }
});

$('#reset-password').click(function () {
  $('#connexion').css('display', 'none');
  $('#reset').fadeIn("slow");
});
'use strict';

$('#accordion-navigation .plus__icon').show();
$('#accordion-navigation').find('li.extend').click(function (e) {
  $(this).children('.extended-submenu').slideToggle('fast');
  $(this).children('.nav--title').children('.plus__icon').toggleClass('opened');
  $(this).toggleClass('active');
});
"use strict";

// Si le client veut la formule RGPD
// --> on supprime ce qui est non commente
// --> on decommente le reste

$(".button--cookie").click(function () {
  $("#cookie--banner").hide();
  $('#page__overlay--cookie').removeClass("opened");
});

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

if (getCookie('cookies-accepted') == 'yes') {} else {
  $("#cookie--banner").addClass("apparition--cookie");
  $('#page__overlay--cookie').addClass("opened");
}

$('#accept--all, #reject--all').on('click', function () {
  var CookieDate = new Date();
  CookieDate.setMonth(CookieDate.getMonth() + 12);
  document.cookie = "cookies-accepted=yes; expires=" + CookieDate.toGMTString() + "; path=/";
});

// window.Shopify.loadFeatures([
//   {
//     name: 'consent-tracking-api',
//     version: '0.1',
//   },
// ], function (error) {
//   if (error) {
//     throw error;
//   }
//   const showBanner = window.Shopify.customerPrivacy.shouldShowGDPRBanner();

//   if (showBanner == true) {
//     setTimeout(function(){
//       $("#cookie--banner").addClass( "apparition--cookie" );
//       $('#page__overlay--cookie').addClass("opened");
//     }, 1000);
//   } else {
//     if (window.Shopify.customerPrivacy.userCanBeTracked()) {
//       document.dispatchEvent(new CustomEvent('trackingConsentAccepted'));
//     }
//   }
// });

// $('#accept--all').on('click', function() {
//   window.Shopify.customerPrivacy.setTrackingConsent(true, function() {
//     $("#cookie--banner").hide();
//     $('#page__overlay--cookie').removeClass("opened");
//   });
// })

// $('#reject--all').on('click', function() {
//   window.Shopify.customerPrivacy.setTrackingConsent(false, function() {
//     $("#cookie--banner").hide();
//     $('#page__overlay--cookie').removeClass("opened");
//   });
// })

// document.addEventListener('trackingConsentAccepted', function (e) {
//   console.log('tracking accepted')
// }, false);
'use strict';

document.addEventListener('cart:open', function (elem) {
  if (window.cart.cartType == 'preview') {
    $('#cart__preview').addClass('opened--added-to-cart');
    $('#page__overlay--cart-preview').addClass('opened');
    $('.special-hover-cart').addClass('opened');
    $("#navigation--container").removeClass('transparent--nav');
    $("#navigation--container").addClass('scrolled--nav filter-drawer-open');
    $('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav, .icon--facebook, .site-header__section--switcher, .swicth-new--container').addClass('filter-open');

    if (window.matchMedia("(max-width: 1100px)").matches) {
      //$('#page__overlay--navigation').addClass('opened');
    } else {
        /*setTimeout(function(){
          $('#cart__preview').removeClass('opened--added-to-cart');
          if ($('#cart__preview').hasClass('opened') == false) {
            $('.link--text-style--cart').removeClass('link__active');
          }
         }, 4000);*/
      }
  } else {
    $("#cart__drawer").addClass('opened');
    $('#page__overlay').addClass('opened');
    $('#page__overlay').attr('for', 'drawer');
    setTimeout(function () {
      $('#drawer__cart--exta-infos').addClass('opened');
    }, 350);
  }
}, false);

// var updateDeliveryModule = function(total) {
//   var remainAmount = Math.max(0 ,( window.crossSell.free_shipping * 100 ) - total)
//   var remainPercentage = (( window.crossSell.free_shipping * 100 ) - total) / window.crossSell.free_shipping
//   var colorBar = 100 - remainPercentage;
//
//   if (colorBar > 100){
//     colorBar = 100
//   }
//   $('#progress__bar--remain').css('width', colorBar + '%')
//
//   if (remainAmount > 0) {
//     $('.free-shipping').hide();
//     $('.remain-shipping').show();
//     $('.amount__remaining').text((remainAmount / 100).toFixed(0) + "€");
//   } else {
//     $('.free-shipping').show();
//     $('.remain-shipping').hide();
//   }
//   /*if (window.cart.deliveryModule) {
//     var deliveryLimit = window.cart.freeDelivery - 1;
//     var remainPercentage = Math.max(0 , (deliveryLimit - total) / deliveryLimit * 100);
//     var remainMoney = Math.max(0 , (deliveryLimit + 1 - total) / 100);
//     var colorBar = 100 - remainPercentage;
//
//     $('#progress__bar--remain').css('width', colorBar + '%')
//
//     if (remainMoney > 0) {
//       $('#free__shipping--message').hide();
//       $('#remain__shipping__amount--message').show();
//       $('.amount__remaining').text(remainMoney + "€");
//     } else {
//       $('#free__shipping--message').show();
//       $('#remain__shipping__amount--message').hide();
//     }
//   }*/
// }
"use strict";

function handleNavbarHover(status) {
  if (window.location.pathname == "/") {

    if (status == "opened") {
            console.log("nocontaine")
      $('#navigation--container').removeClass('transparent--nav essai');
      $('#homepage--link .icon--flowrette-footer').removeClass('logo--white');
      $('.navigation__item--desktop').removeClass('white');
      $('#icon-notif .icon--notif').removeClass('logo--white');
      $('#icon-account .icon--account').removeClass('logo--white');
      $('#icon-cart .icon--cart').removeClass('logo--white');
      $('#icon-search .icon--recherche').removeClass('logo--white');
      $('#icon-underline .icon--soulignement').removeClass('logo--white');
      $('.left-desktop--container .icon--tiktok').removeClass('logo--white');
      $('.left-desktop--container .icon--instagram').removeClass('logo--white');
      $('.left-desktop--container .icon--pinterest').removeClass('logo--white');
      $('#icon-search').removeClass('search-white');
      $('#icon-search .icon--search').removeClass('logo--white');
      $('#icon-search .text-search').removeClass('white');
      $('#icon-notif-device .icon--notif').removeClass('logo--white');
      $('#icon-account-device .icon--account').removeClass('logo--white');
      $('#icon-cart-device .icon--cart').removeClass('logo--white');
      $('#icon-search-mobile .icon--search').removeClass('logo--white');
      $('.menu-mobile .icon--nav').removeClass('logo--white');
    } else {
      console.log("itemcontaine")
      $('#navigation--container').addClass('transparent--nav');
      $('#homepage--link .icon--flowrette-footer').addClass('logo--white');
      $('.navigation__item--desktop').addClass('white');
      $('#icon-notif .icon--notif').addClass('logo--white');
      $('#icon-account .icon--account').addClass('logo--white');
      $('#icon-cart .icon--cart').addClass('logo--white');
      $('#icon-search .icon--recherche').addClass('logo--white');
      $('.left-desktop--container .icon--tiktok').addClass('logo--white');
      $('.left-desktop--container .icon--instagram').addClass('logo--white');
      $('.left-desktop--container .icon--pinterest').addClass('logo--white');
      $('#icon-search').addClass('search-white');
      $('#icon-search .icon--search').addClass('logo--white');
      $('#icon-search .text-search').addClass('white');
      $('#icon-notif-device .icon--notif').addClass('logo--white');
      $('#icon-account-device .icon--account').addClass('logo--white');
      $('#icon-cart-device .icon--cart').addClass('logo--white');
      $('#icon-search-mobile .icon--search').addClass('logo--white');
      $('.menu-mobile .icon--nav').addClass('logo--white');
    }
  }
}

if (window.matchMedia("(min-width: 1101px)").matches) {
  $('.button__action--cart-preview').on('mouseover', function (e) {
    $('#cart__preview').addClass('opened');
    //$('#page__overlay--cart-preview').addClass('opened')
    $('.special-hover-cart').addClass('opened');
    handleNavbarHover("opened");
    //$("#navigation--container").removeClass('transparent--nav');
    //$("#navigation--container").addClass('scrolled--nav filter-drawer-open');
    //$('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav, .icon--facebook, .site-header__section--switcher').addClass('filter-open')
  });
  /*$('.button__action--cart-preview').on('click', function(e) {
    $('#cart__preview').addClass('opened');
    $('#page__overlay--cart-preview').addClass('opened')
    $('.special-hover-cart').addClass('opened')
    handleNavbarHover("opened");
    $("#navigation--container").removeClass('transparent--nav');
    $("#navigation--container").addClass('scrolled--nav filter-drawer-open');
    $('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav, .icon--facebook, .site-header__section--switcher').addClass('filter-open')
  })*/

  $('body').on('mouseleave', '#cart__preview', function () {
    $('#page__overlay--cart-preview').removeClass('opened');
    $('.special-hover-cart').removeClass('opened');
    $('#cart__preview').removeClass('opened');
    $('#cart__preview').removeClass('opened--added-to-cart');

    if (window.general.headerTransparent == 1) {
      if ($(document).scrollTop() > 20) {} else {
        $("#navigation--container").addClass('transparent--nav');
        $("#navigation--container").removeClass('scrolled--nav filter-drawer-open');
        $('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav, .icon--facebook, .site-header__section--switcher, .swicth-new--container').removeClass('filter-open');
      }
    }
  });

  /*$('body').on('click', '#page__overlay--cart-preview, .div-click-cart-preview', function(){
    $('#page__overlay--cart-preview').removeClass('opened')
    $('.special-hover-cart').removeClass('opened')
    $('#cart__preview').removeClass('opened');
    $('#cart__preview').removeClass('opened--added-to-cart');
     if ($(document).scrollTop() > 20) {
    } else {
      $("#navigation--container").addClass('transparent--nav');
      $("#navigation--container").removeClass('scrolled--nav filter-drawer-open');
      $('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav, .icon--facebook, .site-header__section--switcher').removeClass('filter-open')
    }
  })*/
} else {
  $('.button__action--cart-preview').on('click', function (e) {
    $('#cart__preview').addClass('opened');
    //$('#page__overlay--cart-preview').addClass('opened')
    $('.special-hover-cart').addClass('opened');
    $("#navigation--container").removeClass('transparent--nav');
    $("#navigation--container").addClass('scrolled--nav filter-drawer-open');
    $('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav').addClass('filter-open');
  });

  $('body').on('click', '#page__overlay--cart-preview, .div-click-cart-preview, .close-cart-preview', function () {
    $('#page__overlay--cart-preview').removeClass('opened');
    $('.special-hover-cart').removeClass('opened');
    $('#cart__preview').removeClass('opened');
    $('#cart__preview').removeClass('opened--added-to-cart');

    if ($(document).scrollTop() > 20) {} else {
      $("#navigation--container").addClass('transparent--nav');
      $("#navigation--container").removeClass('scrolled--nav filter-drawer-open');
      $('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav').removeClass('filter-open');
    }
  });
  /*$('.button__action--cart-preview').on('click', function() {
    if ($('#cart__preview').hasClass('opened')) {
      $('#cart__preview').removeClass('opened');
      $('#cart__preview').removeClass('opened--added-to-cart');
      $('#page__overlay--navigation').removeClass('opened');
      handleNavbarHover("closed");
    } else {
      $('#cart__preview').addClass('opened');
      //$('#page__overlay--navigation').addClass('opened');
      handleNavbarHover("opened");
    }
  })
   $('.close--cart-preview').on('click', function() {
    $('#cart__preview').removeClass('opened opened--added-to-cart');
    $('#cart__preview').removeClass('opened--added-to-cart');
    $('#page__overlay--navigation').removeClass('opened');
    handleNavbarHover("closed");
  })*/

  $('body').on('click', '#page__overlay--navigation', function () {
    //pour la recherche
    $('.search--container').removeClass('opened opened-scroll opened-mobile-scroll opened-mobile opened-mobile2');
    $('.search--container').css('transform', '');
    $('html, body').css({ overflow: 'visible' });

    $('#cart__preview').removeClass('opened opened--added-to-cart');
    $('#cart__preview').removeClass('opened--added-to-cart');
    $('#page__overlay--navigation').removeClass('opened');
    handleNavbarHover("closed");
  });
}

if ($(document).scrollTop() > 20) {
  $("#cart__preview").css('top', '35px');
}

$(document).on('scroll', function () {
  if ($(document).scrollTop() > 20) {
    $("#cart__preview").css('top', '35px');
  } else {
    $("#cart__preview").css('top', '70px');
  }
});
'use strict';

// Add to cart funnction
if (window.location.pathname == "/cart") {
  window.cart.drawer = false;
}

$('body').on('click', '.add__to__cart', function (e) {
  e.preventDefault();

  var variantId = $(this).attr('variant-id');
  var available = $(this).attr('variant-available');
  var productHandle = $(this).attr('product-handle');
  var variants = $(this).attr('variants');
  var type = $(this).attr('button-type');
  var $this = $(this);

  var valueSize = $('.bulle__custom--value.is__active').attr('value');

  $this.children('.button--text').css('display', 'none');
  $this.children('.button--loading').css('display', 'block');

  if (available == 'true' || available == true) {
    if (variantId) {
      var qty = 1;
      if (type == 'product') {
        qty = $('.product__qty--container .quantity__current').val();
      }
      var objUpdate = { quantity: qty, id: variantId };

      if ($(this).hasClass('etiquette')) {
        var titre = $('.titre-print').text();
        var sousTitre = $('.sous-titre-print').text();
        var format = $('.print--container').attr('format');
        objUpdate.properties = {
          "Titre": titre,
          "Sous-titre": sousTitre,
          "Format": format
        };
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: objUpdate,
        dataType: 'json',
        success: function success(response) {
          updateCartData();
          renderCart();
          document.dispatchEvent(new CustomEvent('update-reco-drawer'));

          if ($('#empty__cart--title').length > 0) {
            location.reload(true);
          }

          //document.dispatchEvent(new CustomEvent('cart:open'));
          $this.children('.button--text').css('display', 'block');
          $this.children('.button--loading').css('display', 'none');

          if (type == 'cross-sell') {
            $this.html('Ajout\xE9<svg class="tick-cross" xmlns="http://www.w3.org/2000/svg" width="8.281" height="7.628" viewBox="0 0 8.281 7.628"><g transform="translate(0.706 0.7)"><line style="fill:none;stroke:#494949;stroke-linecap:round;" x2="2.152" y2="2.402" transform="translate(0 3.819)"/><line style="fill:none;stroke:#494949;stroke-linecap:round;" x1="4.723" y2="6.222" transform="translate(2.152)"/></g></svg>');
            console.log('passe cross sell');
          } else {

            if (window.location.href.indexOf("/products/") > -1) {

              var tailleUnique = $this.attr('taille-unique');
              console.log(tailleUnique);
              if (tailleUnique) {
                valueSize = tailleUnique;
              }

              /*$('#page__overlay').addClass('opened').attr('for', 'modal');
              $('#modal-cross-sell').addClass('opened');*/

              $('.product-select-cross').val(valueSize).trigger('change');

              if (valueSize == 'L') {
                $('.one-product-cross.S, .one-product-cross.M').addClass('hide-product');
                $('.one-product-cross.L').removeClass('hide-product');
              } else if (valueSize == 'M') {
                $('.one-product-cross.S, .one-product-cross.L').addClass('hide-product');
                $('.one-product-cross.M').removeClass('hide-product');
              } else if (valueSize == "S") {
                $('.one-product-cross.M, .one-product-cross.L').addClass('hide-product');
                $('.one-product-cross.S').removeClass('hide-product');
              }
            }
            document.dispatchEvent(new CustomEvent('cart:open'));
          }
        },
        error: function error(_error) {
          console.log('erreur');
          console.log(_error);
        }
      });
    }
  }
});

//   $('body').on('click', '.add__to__cart', function (e) {
//   e.preventDefault();
//   debugger
//   var variantId = $(this).attr('variant-id');
//   var available = $(this).attr('variant-available');
//   var productHandle = $(this).attr('product-handle');
//   var variants = $(this).attr('variants');
//   var type = $(this).attr('button-type');
//   var $this = $(this);

//   var valueSize = $('.bulle__custom--value.is__active').attr('value');

//   $this.children('.button--text').css('display', 'none');
//   $this.children('.button--loading').css('display', 'block');

//   if (available == 'true' || available == true) {
//     if (variantId) {
//       var qty = 1;
//       if (type == 'product') {
//         qty = $('.product__qty--container .quantity__current').val();
//       }
//       var objUpdate = { quantity: qty, id: variantId };

//       if ($(this).hasClass('etiquette')) {
//         var titre = $('.titre-print').text();
//         var sousTitre = $('.sous-titre-print').text();
//         var format = $('.print--container').attr('format');
//         objUpdate.properties = {
//           "Titre": titre,
//           "Sous-titre": sousTitre,
//           "Format": format
//         };
//       }

//       $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: objUpdate,
//         dataType: 'json',
//         success: function success(response) {
//           updateCartData();
//           renderCart();
//           document.dispatchEvent(new CustomEvent('update-reco-drawer'));

//           if ($('#empty__cart--title').length > 0) {
//             location.reload(true);
//           }

//           //document.dispatchEvent(new CustomEvent('cart:open'));
//           $this.children('.button--text').css('display', 'block');
//           $this.children('.button--loading').css('display', 'none');

//           if (type == 'cross-sell') {
//             $this.html('Ajout\xE9<svg class="tick-cross" xmlns="http://www.w3.org/2000/svg" width="8.281" height="7.628" viewBox="0 0 8.281 7.628"><g transform="translate(0.706 0.7)"><line style="fill:none;stroke:#494949;stroke-linecap:round;" x2="2.152" y2="2.402" transform="translate(0 3.819)"/><line style="fill:none;stroke:#494949;stroke-linecap:round;" x1="4.723" y2="6.222" transform="translate(2.152)"/></g></svg>');
//             console.log('passe cross sell');
//           } else {

//             if (window.location.href.indexOf("/products/") > -1) {

//               var tailleUnique = $this.attr('taille-unique');
//               console.log(tailleUnique);
//               if (tailleUnique) {
//                 valueSize = tailleUnique;
//               }

//               /*$('#page__overlay').addClass('opened').attr('for', 'modal');
//               $('#modal-cross-sell').addClass('opened');*/

//               $('.product-select-cross').val(valueSize).trigger('change');

//               if (valueSize == 'L') {
//                 $('.one-product-cross.S, .one-product-cross.M').addClass('hide-product');
//                 $('.one-product-cross.L').removeClass('hide-product');
//               } else if (valueSize == 'M') {
//                 $('.one-product-cross.S, .one-product-cross.L').addClass('hide-product');
//                 $('.one-product-cross.M').removeClass('hide-product');
//               } else if (valueSize == "S") {
//                 $('.one-product-cross.M, .one-product-cross.L').addClass('hide-product');
//                 $('.one-product-cross.S').removeClass('hide-product');
//               }
//             }
//             document.dispatchEvent(new CustomEvent('cart:open'));
//           }
//         },
//         error: function error(_error) {
//           console.log('erreur');
//           console.log(_error);
//         }
//       });
//     }
//   }
// });

$('body').on('click', '.add__to__cart--grid-item', function (e) {
  e.preventDefault();
  var $this = $(this);
  var variant_id = $this.attr('variant-id');
  var qty = 1;
  var objUpdate = { quantity: qty, id: variant_id };
  $.ajax({
    type: "POST",
    url: '/cart/add.js',
    data: objUpdate,
    dataType: "json",
    success: function success(response) {
      updateCartData();
      renderCart();
      document.dispatchEvent(new CustomEvent('update-reco-drawer'));

      setTimeout(function () {
        $this.children('.button--loading').css('display', 'none');
        $this.children('.button--text').show();
      }, 300);

      if (window.matchMedia("(max-width: 767px)").matches) {
        setTimeout(function () {
          $('#drawer__cart--exta-infos').removeClass('opened');
        }, 500);
      }
    },
    error: function error(_error2) {
      console.log('erreur');
      console.log(_error2);
    }
  });
});

$('body').on('change', '.qty--input', function (e) {
   $("#cart__drawer").addClass("lock-drawer");
  e.preventDefault();
  var $this = $(this);
  var variantId = $(this).attr('variant-id');
  var variantQty = $this.val();

  if (variantId) {
    var data = { updates: {} };
    data.updates[variantId] = variantQty;

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function success(response) {
        // On render le cart via le module shippinh-module-cart.js
        updateCartData();
      },
      error: function error(_error3) {
        console.log(_error3.responseJSON.description,'erreur');
        $("#cart-error-notif").addClass("_active");
        $("#cart-error-notif span").html(_error3.responseJSON.description);
        setTimeout(function(){
            $("#cart-error-notif").removeClass("_active");
        },3000)
        $("#cart__drawer").removeClass("lock-drawer");
      },
      success: function(){
           $("#cart__drawer").removeClass("lock-drawer");
      }
    });
  }
});

$('body').on('click', '.quantity__change--selector', function (e) {
  e.preventDefault();
  var $this = $(this);
  var variantId = $(this).attr('variant-id');
  var variantQty = $(this).attr('variant-qty');

  if (variantId) {
    var data = { updates: {} };
    data.updates[variantId] = variantQty;

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function success(response) {
        $('.quantity__current[variant-id="' + variantId + '"]').val(variantQty);
        $('.quantity__change--selector[type="minus"][variant-id="' + variantId + '"]').attr('variant-qty', parseInt(variantQty) - 1);
        $('.quantity__change--selector[type="plus"][variant-id="' + variantId + '"]').attr('variant-qty', parseInt(variantQty) + 1);
        updateCartData();

        if (window.cart && window.cart.drawer) {
          document.dispatchEvent(new CustomEvent('cart:open'));
        }
      },
      error: function error(_error4) {
        console.log('erreur');
      }
    });
  }
});

$('body').on('click', '.remove--line-item', function (e) {
  $("#cart__drawer").addClass("lock-drawer");
  e.preventDefault();
  var $this = $(this);
  var key = $(this).attr('key');

  var data = { updates: {} };
  data.updates[key] = 0;
  setTimeout(function () {
    $('.cart__item--container[key="' + key + '"]').remove();
  }, 300);
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function success(response) {
      updateCartData();
      renderCart();
      document.dispatchEvent(new CustomEvent('update-reco-drawer'));
    },
    error: function error(_error5) {
      console.log(_error5.responseJSON.description,'erreur');
      $("#cart__drawer").removeClass("lock-drawer");
      $("#cart-error-notif").addClass("_active");
        $("#cart-error-notif span").html(_error5.responseJSON.description);
        setTimeout(function(){
            $("#cart-error-notif").removeClass("_active");
        },3000)
    },
    complete:function(){
       $("#cart__drawer").removeClass("lock-drawer");
    }
  });
});

var renderCart = function renderCart() {
  var url = '/cart?view=sidecart&timestamp=' + Date.now();

  /*if (window.general.langue != 'fr'){
    url = `/${window.general.langue}/cart?view=sidecart&timestamp=` + Date.now();
  }*/

  if (window.location.pathname.indexOf('cart') > -1) {
    url = '/cart?view=page&timestamp=' + Date.now();
  }

  $.ajax({
    type: 'GET',
    url: url,
    success: function success(content) {
      
      var newCart = content;

      if (window.location.pathname.indexOf('cart') > -1) {
        $('.cart__items__and__header--container').remove();
        $('.cart__drawer--body').append(newCart);
      } else {
        $('.cart__items__and__header--container').remove();
        $('.cart--body').append(newCart);
      }
    },
    error: function error(_error6) {
      console.log('erreur');
    }
  });
};
  

if (window.cart && window.cart.drawer == true) {
  renderCart();
}

var updateCartData = function updateCartData() {
  var url = '/cart';
  /*if (window.general.langue != 'fr'){
    url = `/${window.general.langue}/cart`
  }*/
  console.log(url);
  $.ajax({
    type: 'GET',
    url: url,
    dataType: 'json',
    success: function success(response) {
      var total = response.total_price;
      var empty = response.item_count == 0 ? true : false;
      updateDeliveryModule(total);
      if (empty) {
        $('.cart--body, .product-reco-mobile--container').addClass('empty__cart');
        $('.cart__total--drawer, .vertical--separator').addClass('display__none');
        $('.empty__cart--drawer').removeClass('display__none');
        $('.items--count').text(0);

        if ($('#full__cart--title').length > 0) {
          location.reload(true);
        }
      } else {
        $('.cart--body, .product-reco-mobile--container').removeClass('empty__cart');
        $('.empty__cart--drawer').addClass('display__none');
        $('.cart__total--drawer, .vertical--separator').removeClass('display__none');
        $('.cart__total--drawer').text(displayPrice(total));

        $('.items--count').text(response.item_count);

        $('.cart__item--total-price').text(displayPrice(total));
        response.items.forEach(function (line_item) {
          var variantId = line_item.variant_id;
          $('.cart__item--container[variant-id=' + variantId + '] .cart__item--total-price').text(displayPrice(line_item.line_price));
        });
      }
    },
    error: function error(_error7) {
      console.log('erreur');
    }
  });
};

/*$('#checkout--button').on('click', function(e) {
  document.location.href = "/en/checkout";
})*/

// Gestion du theme editor
document.addEventListener('update-bar', function (e) {
  updateCartData();
}, false);

var ajaxCartGift = function ajaxCartGift(qty1) {
   
  var objUpdate = { updates: {} };
  objUpdate.updates[41980867543275] = qty1;
  console.log(objUpdate);
 /* $.ajax({
    type: "POST",
    url: '/cart/update.js',
    data: objUpdate,
    dataType: "json",
    success: function success(response) {
      updateCartData();
      renderCart();
    },
    error: function error(_error8) {
      console.log(_error8);
    }
  }); */
};

$(document).ready(function () {
  $('.emballage--container').click(function () {
    if ($(this).find('.checkbox-cart').hasClass('checked')) {
      $('.checkbox-cart').removeClass('checked');
      ajaxCartGift(0);
    } else {
      $('.checkbox-cart').addClass('checked');
      ajaxCartGift(1);
    }
  });
});

if ($('#Commentaire-cart').length > 0) {
  var nbCharacters = $('#Commentaire-cart').val().length;
  $('#compteur--comment').text(nbCharacters);

  $('#Commentaire-cart').on('change keyup', function (e) {
    e.preventDefault();
    nbCharacters = $('#Commentaire-cart').val().length;
    var val = $('#Commentaire-cart').val();

    if (nbCharacters > 140) {
      $('#Commentaire-cart').val(val.substring(0, 140));
      $('#compteur__comment--container').addClass('error');
      $('#compteur--comment').text("140");
      setTimeout(function () {
        $('#compteur__comment--container').removeClass('error');
      }, 600);
    } else {
      $('#compteur--comment').text(nbCharacters);
    }
  });
}

$('#Commentaire-cart').focusout(function () {
  var commentaire = $('#Commentaire-cart').val();
  var objUpdate = {
    note: commentaire
  };
  $.ajax({
    type: "POST",
    url: '/cart/update.js',
    data: objUpdate,
    dataType: "json",
    success: function success(response) {},
    error: function error(_error9) {
      console.log(_error9);
    }
  });
});

$('#partDe-cart').focusout(function () {
  var partDe = $('#partDe-cart').val();
  var objUpdate = {
    attributes: {
      'part-de': partDe
    }
  };
  $.ajax({
    type: "POST",
    url: '/cart/update.js',
    data: objUpdate,
    dataType: "json",
    success: function success(response) {},
    error: function error(_error10) {
      console.log(_error10);
    }
  });
});

$('body').on('click', '#delivery--button', function () {
  $('#delivery--text').slideToggle(200);
});

$('.button-message-cart').on('click', function () {
  $('.textarea-cart--container').slideToggle(200);
  $(this).find('.icon--arrow-bottom').toggleClass('opened');
  $('.product-reco-mobile--container').toggleClass('up');
});
"use strict";

if (window.cart) {
  var deliveryModuleWidth = 100;
  var renderFirst = 0;

  var nbSteps = window.cart.nbSteps;
  if (nbSteps > 1 && nbSteps < 3) {
    deliveryModuleWidth = 33.33;
  } else if (nbSteps > 2) {
    deliveryModuleWidth = 25;
  }
  var ajaxCartProducts = function ajaxCartProducts(qty1, qty2) {
    var objUpdate = { updates: {} };
    objUpdate.updates[41980774023403] = qty1;
    objUpdate.updates[41980774318315] = qty2;

   /* $.ajax({
      type: "POST",
      url: '/cart/update.js',
      data: objUpdate,
      dataType: "json",
      success: function success(response) {
        renderCart();
      },
      error: function error(_error) {
        console.log(_error);
      }
    }); */
  };

  var shippingBarLogic = function shippingBarLogic(total) {
    var currentStep = 1;
    if (total >= window.cart.steps[0] && total < window.cart.steps[1]) {
      currentStep = 2;
    } else if (total >= window.cart.steps[1]) {
      currentStep = 3;
    }
    //var currentStep = window.cart.nbSteps

    var remainMoney = 0;
    var remainPercentage = 0;
    var colorBar = 0;

    var barCalculus = function barCalculus(step, total) {
      var seuilSuivant = window.cart.steps[step - 1];
      var seuilPrecedent = 0;
      if (step != 1) {
        seuilPrecedent = window.cart.steps[step - 2];
      }
      remainMoney = Math.max(0, (seuilSuivant - total) / 100);
      remainPercentage = Math.max(0, (seuilSuivant - total) / (seuilSuivant - seuilPrecedent));
      colorBar = deliveryModuleWidth * step - deliveryModuleWidth * remainPercentage;
    };

    var finalStep = function finalStep() {
      remainMoney = 0;
      remainPercentage = 0;
      colorBar = 100;
    };

    switch (currentStep) {
      case 1:
        barCalculus(1, total);
        break;
      case 2:
        barCalculus(2, total);
        break;
      case 3:
        barCalculus(3, total);
        break;
      default:
        break;
    }

    if (currentStep == 1) {
      ajaxCartProducts(0, 0);
    } else if (currentStep == 2 && nbSteps > 1) {
      if (nbSteps == 1) {
        finalStep();
      } else {
        if (window.cart.deliveryStep == 1) {
          ajaxCartProducts(0, 0);
        } else {
          ajaxCartProducts(1, 0);
        }
      }
    } else {
      finalStep();
      if (window.cart.deliveryStep == 0 && nbSteps == 2) {
        ajaxCartProducts(1, 1);
      } else if (window.cart.deliveryStep == 0 && nbSteps == 1) {
        ajaxCartProducts(1, 0);
      } else if ((window.cart.deliveryStep == 1 || window.cart.deliveryStep == 2) && nbSteps == 2) {
        ajaxCartProducts(1, 0);
      } else {
        ajaxCartProducts(0, 0);
      }
    }

    $('.progress__bar--remain').css('width', colorBar + '%');

    if (remainMoney > 0) {
      var moinsDix = remainMoney < 10 ? true : false;
      remainMoney = remainMoney.toString().replace('.', ',');
      if (moinsDix == true && remainMoney.length == 3) {
        remainMoney = remainMoney + '0';
      } else if (moinsDix == false && remainMoney.length == 4) {
        remainMoney = remainMoney + '0';
      }

      $('#free__shipping--message').hide();
      $('#remain__shipping__amount--message').show();
      $('.amount__remaining').text(remainMoney + "€");
    } else {
      $('#free__shipping--message').show();
      $('#remain__shipping__amount--message').hide();
    }
  };

  var getCartTotal = function getCartTotal(callback, cart) {
    if (cart) {
      if (callback) {
        callback(cart.total_price);
      } else {
        return cart.total_price;
      }
    } else {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function success(cart) {
          if (callback) {
            callback(cart.total_price);
          } else {
            return cart.total_price;
          }
        }
      });
    }
  };

  var initializeDeliveryModule = function initializeDeliveryModule() {
    var total = getCartTotal(shippingBarLogic);
  };

  setTimeout(function () {
    initializeDeliveryModule();
  }, 1000);

  var updateDeliveryModule = function updateDeliveryModule(total) {
    console.log('update');
    if (window.cart.deliveryModule) {
      if (total) {
        shippingBarLogic(total);
      } else {
        getCartTotal(shippingBarLogic);
      }
    }
  };
}
"use strict";

var emballageCadeauVariantId = window.giftBoxvariant;
$(".emballage__cadeau--button").on("click", function () {
  var data = { updates: {} };
  data.updates[emballageCadeauVariantId] = 1;
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function success() {
      location.reload();
    }
  });
});
'use strict';

document.addEventListener('update-reco-drawer', function (e) {
  var url = 'https://' + window.location.hostname + '/?section_id=legacy-reco-lateral';
  if (window.general.langue != 'fr') {
    url = 'https://' + window.location.hostname + '/' + window.general.langue + '/?section_id=legacy-reco-lateral';
  }
  $.ajax({
    type: 'GET',
    url: url,
    success: function success(data) {
      $('#product-reco--container, #product-reco--container-mobile').empty().append(data);
      if (window.matchMedia("(max-width: 767px)").matches) {
        $('#reco__lateral--container .reco__lateral--products').slick({
          dots: false,
          infinite: true,
          arrows: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
    },
    error: function error(_error) {
      console.log('erreur');
      console.log(_error);
    }
  });
}, false);

$('body').on('click', '.reco--aded-to-cart', function (e) {
  var handle = $(this).attr('product-handle');
  if (typeof ga === "function") {
    ga('send', 'event', 'Produit recommandé', 'Ajout au panier', handle);
  }
});

// document.dispatchEvent(new CustomEvent('update-reco-drawer')); --> a ajouter lors des ajouts au panier
'use strict';

if (window.collection) {
  var selectedInput = $('.select__custom--value[value="' + window.collection.defaultSortBy + '"]').first().text();

  $('.select__custom--value[value="' + window.collection.defaultSortBy + '"]').addClass('is__active');

  if (window.matchMedia("(min-width: 768px)").matches) {
    $('.select__custom--selected-value').text(selectedInput);
  }
}
'use strict';

// Filters
$('body').on('click', '.reinitialize__filters', function () {
  window.collection.currentFilters = [];
  $('.reinitialize__filters').hide();
  $('.filter__item--mini').remove();
  $('.filter__button').removeClass('is__active');
  var filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '?sort_by=' + window.collection.sortBy;
  if (history.replaceState) {
    window.history.replaceState({ path: filteredUrl }, '', filteredUrl);
  }
  $.ajax({
    type: 'GET',
    url: filteredUrl + '&view=filtered',
    success: function success(content) {
      var count = parseInt(content.substring(0, 4));
      $('.filter-count').text(count);
      $('#collection__list--container').remove();
      $('#collection__page--desktop').append(content.substring(4));
    },
    error: function error(_error) {
      console.log('erreur');
    }
  });
});

$('body').on('click', '.filter__item--mini', function () {
  var filter_value = $(this).attr('filter-value-handle');
  $('.filter__item--mini[filter-value-handle=' + filter_value + ']').remove();
  $('.filter__button[filter-value-handle=' + filter_value + ']')[0].click();
});

$('body').on('click', '.filter__button', function () {
  var mini__filter = window.collection.miniFilter;
  var filter_value = $(this).attr('filter-value-handle'),
      filteredUrl = '';
  var filtersList = window.collection.currentFilters;

  if ($(this).hasClass('is__active')) {
    $('.filter__button[filter-value-handle=' + filter_value + ']').removeClass('is__active');

    filtersList.splice(filtersList.indexOf(filter_value), 1);

    window.collection.currentFilters = filtersList;
    window.collection.currentFilters.sort();

    $('.filter__item--mini[filter-value-handle=' + filter_value + ']').remove();
  } else {
    // Supprime les tags du meme groupe deja actifs
    var group = filter_value.split('_')[0];
    $('.filter__button[filter-group-handle="' + group + '"]').removeClass('is__active');
    $('.filter__item--mini[filter-group-handle="' + group + '"]').remove();
    $('.filter__button[filter-value-handle=' + filter_value + ']').addClass('is__active');
    for (var i = 0; i < filtersList.length; i++) {
      if (filtersList[i].indexOf(group) > -1) {
        filtersList.splice(i, 1);
      }
    }

    window.collection.currentFilters = filtersList;
    window.collection.currentFilters.push(filter_value);
    window.collection.currentFilters.sort();

    $('.filter__values--list').append('<li class="filter__item--mini body--text--footer" filter-value-handle="' + filter_value + '" filter-group-handle="' + group + '"><span>' + $(this).attr('filter-group') + ': ' + $(this).attr('filter-value') + '</span><span class="close close__filter"></span></li>');
  }

  if (window.collection.currentFilters.length > 0) {
    $('.reinitialize__filters').show();
    filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '/' + window.collection.currentFilters.join('+') + '?sort_by=' + window.collection.sortBy;
  } else {
    $('.reinitialize__filters').hide();
    filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '?sort_by=' + window.collection.sortBy;
  }

  if (history.replaceState) {
    window.history.replaceState({ path: filteredUrl }, '', filteredUrl);
  }

  $.ajax({
    type: 'GET',
    url: filteredUrl + '&view=filtered',
    success: function success(content) {
      var count = parseInt(content.substring(0, 4));
      $('.filter-count').text(count);
      $('#collection__list--container').remove();
      $('#collection__page--desktop').append(content.substring(4));
    },
    error: function error(_error2) {
      console.log('erreur');
    }
  });
});

// mobile
$('.action--button-validate').on('click', function (e) {
  e.preventDefault();
  $('#navigation__drawer--header .close').click();
});
$('.action--button-close').on('click', function (e) {
  e.preventDefault();
  $('#navigation__drawer--header .close').click();
});

$('.filter__group--title').on('click', function () {
  $(this).children('plus__icon').toggleClass('opened');
  $(this).siblings('.filter__group--item-list').slideToggle(300);
  $(this).toggleClass('opened');
});

if (window.location.href.indexOf("collections/") > -1 && window.general.collection == "true") {
  var printUrl = function printUrl(list) {
    var filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + "?";
    // for (var filter in list) {
    //   filteredUrl += list[filter].type + "=" + list[filter].value + "&";
    // }
 for (var filter in list) {
    var encodedValue = encodeURIComponent(list[filter].value);  // URL encode the filter value
    filteredUrl += encodeURIComponent(list[filter].type) + "=" + encodedValue + "&";
  }
    var sortBy = $('#sort__by--container .select__custom--value.is__active').attr('value');
    var filterSortBy = 'sort_by=' + sortBy;

    var pageUrl = '';
    if (window.location.href.indexOf('page=') > -1) {
      var url_string = window.location.href;
      var url = new URL(url_string);
      var numberPage = url.searchParams.get("page");
      pageUrl = "&page=" + numberPage;
    }

    var finalUrl = filteredUrl + filterSortBy + pageUrl;

    if (history.replaceState) {
      window.history.replaceState({ path: finalUrl }, '', finalUrl);
    }

    $.ajax({
      type: 'GET',
      url: finalUrl + '&view=filtered',
      success: function success(content) {
        console.log("content",content)
        var count = parseInt(content.substring(0, 4));
        $('.filter-count').text(count);
        $('#collection__list--container').remove();
        $('#collection__page--desktop').append(content.substring(4));

        clearFilter();
      },
      error: function error(_error3) {
        console.log('erreur');
        console.log(_error3);
      }
    });
  };

  var collectionFilter = {};
  if ($('[collection-filter]').html()) {
    collectionFilter = JSON.parse($('[collection-filter]').html());
  }

  //Range slider price
  var $range = $(".js-range-slider"),
      $from = $(".from"),
      $to = $(".to"),
      range,
      min = $range.data('min'),
      max = $range.data('max'),
      from,
      to;

  var updateValues = function updateValues() {
    $from.prop("value", from);
    $to.prop("value", to);

    dataFilter = boucleFilter();
    printUrl(dataFilter);
  };

  var updateFilter = function updateFilter() {
    var maxRange = collectionFilter.filterMaxRange / 100;
    if (from == '0' && to == maxRange) {
      $('.active-filters__remove-filter[filtername="filter-price"]').hide();
    } else {
      $('.active-filters__remove-filter[filtername="filter-price"]').show();
      $('.min-value-filter').text(from + "€");
      $('.max-value-filter').text(to + "€");
    }
  };

  $range.ionRangeSlider({
    onChange: function onChange(data) {
      from = data.from;
      to = data.to;
      updateValues();
      updateFilter();
      $('.irs-from, .irs-to').append(' €');
    }
  });

  $(window).bind("load", function () {
    $('.irs-from, .irs-to').append(' €');
  });

  range = $range.data("ionRangeSlider");
  var updateRange = function updateRange() {
    range.update({
      from: from,
      to: to
    });
  };

  $from.on("input", function () {
    from = +$(this).prop("value");
    if (from < min) {
      from = min;
    }
    if (from > to) {
      from = to;
    }
    updateValues();
    updateRange();
    updateFilter();
  });

  $to.on("input", function () {
    to = +$(this).prop("value");
    if (to > max) {
      to = max;
    }
    if (to < from) {
      to = from;
    }
    updateValues();
    updateRange();
    updateFilter();
  });

  $(document).ready(function () {
    if (collectionFilter.filterMaxValue != '') {
      to = collectionFilter.filterMaxValue / 100;
    }
    if (collectionFilter.filterMinValue != '') {
      from = collectionFilter.filterMinValue / 100;
    }

    //updateValues();
    updateRange();
  });

  var clearFilter = function clearFilter() {
    var url = window.location.href;
    var matches = url.match(/[a-z\d]+=[a-z\d]+/gi);
    var count = matches ? matches.length : 0;
    if (window.location.search.indexOf('page=') > -1) {
      count = count - 1;
    }
    /*if(count > 1 ){
      $('.active-filters__clear').show()
    } else {
      $('.active-filters__clear').hide()
    }*/
  };

  $(document).ready(function () {
    clearFilter();
  });

  var dataFilter = [];

  var boucleFilter = function boucleFilter() {
      var array = [];
    $(".filter-group-display__list").each(function () {
      var containerFilter = $(this).children('.filter-group-display__list-item');

      var checkbox = containerFilter.children('.filter--container').children('.checkbox-filter--container');
      var value = "";
      var name = checkbox.attr('name');
      var compteurCheck = 0;
      for (var i = 1; i <= containerFilter.length; i++) {

        var loopCheckbox = containerFilter.children('.filter--container').children('.checkbox-' + i);

        if (loopCheckbox.hasClass('checked')) {
                  console.log(loopCheckbox)
          compteurCheck += 1;
      compteurCheck > 0 ? array.push({ type: name, value: loopCheckbox.attr('value') }) : null;
          // compteurCheck == 1 ? value = loopCheckbox.attr('value') : value = value + ',' + loopCheckbox.attr('value');
        }
      }
      // compteurCheck > 0 ? array.push({ type: name, value: value }) : null;
    });

    var nameFilterLow = $('#lowPriceFilter').attr('name');
    var valueLow = $('#lowPriceFilter').val();

    var nameFilterHigh = $('#highPriceFilter').attr('name');
    var valueHigh = $('#highPriceFilter').val();
    var maxValueHigh = $('#highPriceFilter').attr('max');

    if (parseInt(valueLow) > 0) {
      array.push({ type: nameFilterLow, value: valueLow });
    }

    if (parseInt(valueHigh) < parseInt(maxValueHigh)) {
      array.push({ type: nameFilterHigh, value: valueHigh });
    }

    return array;
  };

  if (window.location.href.indexOf("collections") > -1) {
    dataFilter = boucleFilter();
  }

  $('body').on('click', '.filter--container', function () {
    if ($(this).find('.checkbox-filter--container').hasClass('checked')) {
      var filterName = $(this).find('.checkbox-filter--container').attr('filtername');
     var escapedFilterName = filterName.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
  
  // Remove the filter if it exists
  $('.active-filters__remove-filter[filtername="' + escapedFilterName + '"]').remove();
    } else {
      var filterName = $(this).find('.checkbox-filter--container').attr('filtername');

      if (filterName == 'Disponibilité-Enstock') {
        var filterValue = 'En stock';
      } else {
        var filterValue = $(this).find('.checkbox-filter--container').attr('value');
      }
      $('.active-filters').append('\n    <a class="active-filters__remove-filter cursor--pointer" filtername="' + filterName + '">\n        ' + filterValue + ' X\n    </a>\n  ');
    }

    var checkboxContainer = $(this).children('.checkbox-filter--container');
    checkboxContainer.hasClass('checked') ? checkboxContainer.removeClass('checked') : checkboxContainer.addClass('checked');
    $(this).hasClass('checked') ? $(this).removeClass('checked') : $(this).addClass('checked');

    dataFilter = boucleFilter();
    printUrl(dataFilter);
  });

  $('body').on('click', '.active-filters__remove-filter', function () {
    var filterName = $(this).attr('filtername');
    if (filterName == "filter-price") {
      $('.active-filters__remove-filter[filtername="filter-price"]').hide();
      $('#lowPriceFilter').attr('value', 0);
      var maxRangeValue = collectionFilter.filterMaxRange / 100;

      $('#highPriceFilter').attr('value', maxRangeValue);
      $('#highPriceFilter').val(maxRangeValue);
      to = maxRangeValue;
      from = 0;
      updateValues();
      updateRange();
    } else {
      $(this).remove();
      $('.checkbox-filter--container[filtername=' + filterName + ']').removeClass('checked');
    }
    dataFilter = boucleFilter();
    printUrl(dataFilter);
  });

  var countEuro = 1;
  $('body').on('click', '.filter-group-summary', function () {

    if ($(this).hasClass('checked')) {
      $(this).removeClass('checked');
      $(this).siblings('.filter-group-display').slideToggle(200);
      $(this).children('.icon--arrow-bottom').removeClass('opened');
    } else {
      $(this).addClass('checked');
      $(this).siblings('.filter-group-display').slideToggle(200);
      $(this).children('.icon--arrow-bottom').addClass('opened');

      setTimeout(function () {
        if (countEuro == 1) {
          countEuro = countEuro + 1;
          $('.irs-from, .irs-to').append(' €');
        }
      }, 200);
    }
  });
}
'use strict';

$('.product__item__link--container').on('click', function (e) {
  e.preventDefault();
  if ($(e.target).is('.property--item')) {
    var url = $(e.target).attr('link');
    window.location.href = url;
  } else {
    window.location = this.href;
  }
});
'use strict';

// Ouvrir la modal au clic
$('body').on('click', '.button__action', function (e) {
  e.preventDefault();
  var buttonFor = $(this).attr('for');
  var selector = $(this).attr('open-selector');
  if (selector) {
    $(selector).addClass('opened');
    if (buttonFor == "drawer-filter") {
      $('#page__overlay-filter').addClass('opened');
    } else {
      $('#page__overlay').addClass('opened');
    }
  }

  if (buttonFor == 'modal' && selector) {
    $('#page__overlay').attr('for', 'modal');
  } else if (buttonFor == 'drawer' && selector) {
    if (selector == '#navigation__drawer') {
      if ($("#navigation--container").hasClass('filter-drawer-open')) {
        $('#filter-collection-drawer').removeClass('opened');
        $('#page__overlay-filter').removeClass('opened');
        if ($(document).scrollTop() < 20) {
          $("#navigation--container").addClass('transparent--nav');
          $("#navigation--container").removeClass('scrolled--nav filter-drawer-open');
        } else {
          $("#navigation--container").removeClass('filter-drawer-open');
        }
        $('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav').removeClass('filter-open');
      }
    }
    $('#page__overlay').attr('for', 'drawer');
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({ overflow: 'hidden' });
    }
  } else if (buttonFor == 'drawer-filter') {
    $("#navigation--container").removeClass('transparent--nav');
    $("#navigation--container").addClass('scrolled--nav filter-drawer-open');
    $('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav').addClass('filter-open');
  } else if (buttonFor == 'drawer-reco' && selector) {
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({ overflow: 'hidden' });
    }
    if (window.matchMedia("(max-width: 949px)").matches) {
      $('#page__overlay--reco').addClass('opened');
    }
  } else if (buttonFor == 'drawer-cart' && selector) {
    console.log('passe cart');
    $('#page__overlay').attr('for', 'drawer');
    if ($("#navigation--container").hasClass('filter-drawer-open')) {
      $('#filter-collection-drawer').removeClass('opened');
      $('#page__overlay-filter').removeClass('opened');
      if ($(document).scrollTop() < 20) {
        $("#navigation--container").addClass('transparent--nav');
        $("#navigation--container").removeClass('scrolled--nav filter-drawer-open');
      } else {
        $("#navigation--container").removeClass('filter-drawer-open');
      }
      $('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav').removeClass('filter-open');
    }
    /*if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({overflow: 'hidden'});
    }*/
    if (window.matchMedia("(min-width: 768px)").matches) {
      setTimeout(function () {
        $('#drawer__cart--exta-infos').addClass('opened');
      }, 350);
    }
  } else if (buttonFor == 'accordeon') {
    var isActive = false;
    if ($(this).hasClass('active')) {
      isActive = true;
    }
    if ($(this).hasClass('link--item-button')) {
      $('.link--item-button.active').siblings('.accordeon__list').removeClass('opened').slideToggle('500');
      $('.link--item-button.active').children('.icon--arrow-bottom').removeClass('opened');
      $('.link--item-button.active').children('.plus__icon').removeClass('opened');
      $('.link--item-button.active').removeClass('active');
    } else if ($(this).hasClass('sub__link--item-button')) {
      $('.sub__link--item-button.active').siblings('.accordeon__list').removeClass('opened').slideToggle('500');
      $('.sub__link--item-button.active').children('.icon--arrow-bottom').removeClass('opened');
      $('.sub__link--item-button.active').children('.plus__icon').removeClass('opened');
      $('.sub__link--item-button.active').removeClass('active');
    }

    if (isActive == false) {
      $(this).toggleClass('active');
      $(this).children('.icon--arrow-bottom').toggleClass('opened');
      $(this).children('.plus__icon').toggleClass('opened');
      $(this).siblings('.accordeon__list').addClass('opened').slideToggle('500');
    }
  }
  if (buttonFor == 'select' && selector) {
    $('#page__overlay').attr('for', 'select');
  }
});

// Fermer la modal au clic sur la croix
$('body').on('click', '.close', function (e) {
  e.preventDefault();
  var closeFor = $(this).attr('for');

  if (closeFor == 'drawer-reco') {} else {
    $('#page__overlay').removeClass('opened');
    $('#page__overlay').attr('for', '');
  }

  if (closeFor == 'modal') {
    $('.modal').removeClass('opened');
    $('.modal-loader').show();
    $('.modal-has-to-load').hide();
  } else if (closeFor == 'drawer-filter') {
    $('#filter-collection-drawer').removeClass('opened');
    $('#page__overlay-filter').removeClass('opened');
    if ($(document).scrollTop() < 20) {
      $("#navigation--container").addClass('transparent--nav');
      $("#navigation--container").removeClass('scrolled--nav filter-drawer-open');
    } else {
      $("#navigation--container").removeClass('filter-drawer-open');
    }
    $('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav').removeClass('filter-open');
  } else if (closeFor == 'drawer-reco') {
    $('#drawer__cart--exta-infos').removeClass('opened');
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({ overflow: 'visible' });
    }
    if (window.matchMedia("(max-width: 949px)").matches) {
      $('#page__overlay--reco').removeClass('opened');
    }
  } else if (closeFor == 'drawer') {
    $('.drawer').removeClass('opened');
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({ overflow: 'visible' });
    }
  } else if (closeFor == 'select') {
    $('.select').removeClass('opened');
  }
});

$('#page__overlay-filter').on('click', function (e) {
  e.preventDefault();

  $(this).removeClass('opened');
  $('#page__overlay-modal').attr('for', '');
  $('#filter-collection-drawer').removeClass('opened');

  if ($(document).scrollTop() < 20) {
    $("#navigation--container").addClass('transparent--nav');
    $("#navigation--container").removeClass('scrolled--nav filter-drawer-open');
  } else {
    $("#navigation--container").removeClass('filter-drawer-open');
  }
  $('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav').removeClass('filter-open');
});

// Clic en dehors de la'modal'
$('#page__overlay').on('click', function (e) {
  e.preventDefault();
  var overlayFor = $(this).attr('for');

  $(this).removeClass('opened');
  $('#page__overlay').attr('for', '');

  if (overlayFor == 'modal') {
    $('.modal').removeClass('opened');
    $('.modal-loader').show();
    $('.modal-has-to-load').hide();
  } else if (overlayFor == 'drawer') {
    $('.drawer').removeClass('opened');
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({ overflow: 'visible' });
    }
  } else if (overlayFor == 'select') {
    $('.select').removeClass('opened');
  }
});

// Ajout de la variant lors de la selection + Fermer modal
$('.variant__select').on('click', function (e) {
  //$('#iddeclasse').attr('variant', $(this).attr("value"));
  e.preventDefault();
  $('.select').removeClass('opened');
  var closeFor = $(this).attr('for');
  $('#page__overlay').removeClass('opened');
  $('#page__overlay').attr('for', '');
});

$('#page__overlay--reco').on('click', function (e) {
  e.preventDefault();
  $(this).removeClass('opened');
  $('#drawer__cart--exta-infos').removeClass('opened');
});

$('#page__overlay--white').on('click', function (e) {
  e.preventDefault();
  $(this).removeClass('opened');
  $('.select__custom--values').hide();
  $('.select__custom--values').removeClass('opened');
});
"use strict";
'use strict';

// Click sur le select
$('body').on('click', '.select__custom--selected-value-container', function (e) {
  var forSelect = $(this).attr('for');
  $('.select__custom--values[for="' + forSelect + '"]').fadeToggle(50);
  $('.select__custom--values[for="' + forSelect + '"]').hasClass('opened') ? $('.select__custom--values[for="' + forSelect + '"]').removeClass('opened') : $('.select__custom--values[for="' + forSelect + '"]').addClass('opened');
  //$('#page__overlay--white').addClass('opened')
});

$(document).on('click', function (e) {

  var container = $(".select__custom--values");
  var container2 = $(".select__custom--container");
  var container3 = $('.select__custom--selected-value-container');
  var container4 = $('.text-button-trier');
  if (container.is(e.target) || container2.is(e.target) || container3.is(e.target) || container4.is(e.target)) {} else {
    if (container.hasClass('opened')) {
      $('.select__custom--values').fadeToggle(50);
      $('.select__custom--values').removeClass('opened');
    }
  }
});

$('body').on('click', '.select__custom--value', function (e) {
  var forSelect = $(this).attr('for');
  var value = $(this).attr('value');
  var valueText = $(this).text();
  //est ce quon a modifie un select via quick view
  var quickAdd = $(this).attr('product-grid') || "false";

  $('.select__custom--value[for="' + forSelect + '"]').removeClass('is__active');
  $(this).addClass('is__active');

  $('.select__custom--selected-value[name="' + forSelect + '"]').text(valueText);
  $('.select__hidden[for="' + forSelect + '"]').val(value).trigger('change');
  $('.select__custom--values').hide();
  $('.select__custom--values').removeClass('opened');
  $('#page__overlay--white').removeClass('opened');
  document.dispatchEvent(new CustomEvent('select-changed:' + forSelect, { 'detail': { quickAdd: quickAdd } }));
});

// Sort
Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
$('.select__hidden[for="sort--by"]').bind('change', function () {
  Shopify.queryParams.sort_by = $(this).val();
  location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
});
'use strict';

var prevArrow = '<svg class="slick-arrow--left" viewBox="0 0 53.4 18.8"><defs><style>.cls-1{fill:#404040;}</style></defs><path class="cls-1" d="M0,9.3V10a.1.1,0,0,0,.1.1v.1h0l.1.1h0l10,8a1,1,0,0,0,1.2-1.6L3.6,10.5H51.9a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H3.8l7.8-6.2A1.08,1.08,0,0,0,11.8.9,1.23,1.23,0,0,0,11,.5a1.42,1.42,0,0,0-.6.2l-10,8h0l-.1.1h0v.1L.2,9C0,9.2,0,9.2,0,9.3Z"/></svg>';
var nextArrow = '<svg class="slick-arrow--right" x="0px" y="0px"viewBox="0 0 53.4 18.8" style="enable-background:new 0 0 53.4 18.8;" xml:space="preserve"> <style type="text/css"> .st0{fill:#404040;} </style> <path class="st0" d="M52.9,9.7V9.6V9.5c0,0,0,0,0-0.1s0,0,0-0.1V9.2V9.1V9c0,0,0-0.1-0.1-0.1V8.8l0,0l-0.1-0.1l0,0l-10-8 c-0.4-0.3-1.1-0.3-1.4,0.2C41,1.3,41,2,41.5,2.3l7.8,6.2H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h48.1l-7.8,6.2c-0.4,0.3-0.5,1-0.2,1.4 c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2l10-8l0,0l0.1-0.1l0,0v-0.1l0.1-0.1C52.9,9.8,52.9,9.8,52.9,9.7z"/> </svg>';

var initSlick = function initSlick() {

  $('.background-slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  });

   $('.slider-client-logo').slick({
    dots: false,
    infinite: false,
    arrows: false,
    // prevArrow: prevArrow,
    // nextArrow: nextArrow,
    slidesToShow: 5,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 3000
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  
$(".buy_together_product_slider").each(function (index) {
  var $this = $(this);
  $this.slick({
 dots: false,
    infinite: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
       prevArrow: $this.parents(".product-metafield-display").find(".prev-btn"),
    nextArrow: $this.parents(".product-metafield-display").find(".next-btn")
  })
})





  $('.carousel-product-list').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 950,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }]
  });

  $('.blog-slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('#instagram-feed').slick({
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1000,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 3
      }
    }]
  });

  $('#bandeau--footer-slider').slick({
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 950,
      settings: {
        slidesToShow: 2
      }
    }]
  });
  $('.slider-collection-home').slick({
    dots: false,
    infinite: true,
    arrows: true,
    nextArrow: nextArrow,
    slidesToScroll: 1,
    variableWidth: true
  });
  $('.slider-collection-home_mobi').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    cssEase: 'linear',
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 950,
      settings: {
        slidesToShow: 2,
        arrows: false,
        dots: true,
        customPaging: function customPaging(slider, i) {
          return '<button class="tab"></button>';
        }
      }
    }, {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true,
        customPaging: function customPaging(slider, i) {
          return '<button class="tab"></button>';
        }
      }
    }]
  });
  $('.slider-review').slick({
    dots: true,
    customPaging: function customPaging(slider, i) {
      return '<button class="tab"></button>';
    },
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  if (window.matchMedia("(max-width: 767px)").matches) {
    $('.slider-home-bandeau').slick({
      dots: false,
      infinite: true,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true
    });

    $('.slider-footer-bandeau').slick({
      dots: true,
      customPaging: function customPaging(slider, i) {
        return '<button class="tab"></button>';
      },
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true
    });
  }

  $('.slider-header-cart').slick({
    dots: true,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    customPaging: function customPaging(slider, i) {
      return '<button class="tab"></button>';
    }
  });

$('.client-reviews-slider').each(function() {
var $this = $(this);
  $this.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
  arrows: true,

nextArrow:$this.parents(".reviews-container").find(".next-btn"),
       prevArrow: $this.parents(".reviews-container").find(".prev-btn"),
  
    centerMode: false,
    responsive: [
    {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
})

  

  //  // Custom Buttons
  // const $clientPrevButton = $('#landing-review-prev-slide');
  // const $clientNextButton = $('#landing-review-next-slide');

  // // Function to update button states
  // function updateButtonStates2(currentSlide, totalSlides) {
  //   if (currentSlide === 0) {
  //     $clientPrevButton.prop('disabled', true); // Disable previous button
  //   } else {
  //     $clientPrevButton.prop('disabled', false); // Enable previous button
  //   }

  //   if (currentSlide === totalSlides - 1) {
  //     $clientNextButton.prop('disabled', true); // Disable next button
  //   } else {
  //     $clientNextButton.prop('disabled', false); // Enable next button
  //   }
  // }

  // // Attach click events to custom buttons
  // $clientPrevButton.on('click', function () {
  //   $('.client-reviews-sliderr').slick('slickPrev'); // Go to the previous slide
  // });

  // $clientNextButton.on('click', function () {
  //   $('.client-reviews-slider').slick('slickNext'); // Go to the next slide
  // });

  // // Initial state update
  // const totalSlides2 = $('.client-reviews-sliderr .slick-slide').not('.slick-cloned').length;
  // updateButtonStates2(0, totalSlides2);

  // // Update button states on slide change
  // $('.client-reviews-slider').on('afterChange', function (event, slick, currentSlide) {
  //   updateButtonStates2(currentSlide, totalSlides);
  // });

  
  $('.slider-logo-marque').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  $('.slider-collection-selection').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 500,
      settings: {
        slidesToShow: 2
      }
    }]
  });
  $('.slider-categorie-blog').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 500,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  $('.slider-collection-revendeur').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 500,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  if (screen.width < 768) {} else {
    $('.slider-collection-ville').slick({
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 3,
      slidesToScroll: 1
    });
  }

  $('.slider-image-boutique').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToScroll: 1,
    slidesToShow: 1
  });

  $('.slider-product-cross').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToScroll: 1,
    slidesToShow: 3,
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 500,
      settings: {
        slidesToShow: 1
      }
    }]
  });
};

initSlick();

document.addEventListener('theme-editor--slick', function (e) {
  $('.background-slider').filter('.slick-initialized').slick('unslick');
  $('.carousel-product-list').filter('.slick-initialized').slick('unslick');
  $('.blog-slider').filter('.slick-initialized').slick('unslick');
  $('#instagram-feed').filter('.slick-initialized').slick('unslick');
  $('#bandeau--footer-slider').filter('.slick-initialized').slick('unslick');

  initSlick();
}, false);
'use strict';

var announcementDetails = {};
if ($('[announcement-details]').html()) {
  announcementDetails = JSON.parse($('[announcement-details]').html());
}

var text_ecran = announcementDetails.text_ecran;
var text_mobile = announcementDetails.text_mobile;
var lien_ecran = announcementDetails.lien_ecran;
var lien_mobile = announcementDetails.lien_mobile;
var counter = 1;
var elem = $("#annonce");

if (window.matchMedia("(min-width: 767px)").matches) {
  var change = function change() {
    if (text_ecran && text_ecran.length > 1) {
      elem.fadeOut(function () {
        elem.html(text_ecran[counter]);
        if (lien_ecran[counter] != "unlink") {
          elem.attr("href", lien_ecran[counter]);
        } else {
          elem.removeAttr('href');
        }
        counter++;
        if (counter >= text_ecran.length) {
          counter = 0;
        }
        elem.fadeIn();
      });
    }
  };

  if (lien_ecran && lien_ecran[0] != "unlink") {
    elem.attr("href", lien_ecran[0]);
  } else {
    elem.removeAttr('href');
  }
  setInterval(change, 6000);
} else {
  var _change = function _change() {
    if (text_mobile && text_mobile.length > 1) {
      elem.fadeOut(function () {
        elem.html(text_mobile[counter]);
        if (lien_mobile[counter] != "unlink") {
          elem.attr("href", lien_mobile[counter]);
        } else {
          elem.removeAttr('href');
        }
        counter++;
        if (counter >= text_mobile.length) {
          counter = 0;
        }
        elem.fadeIn();
      });
    }
  };

  if (lien_ecran && lien_mobile[0] != "unlink") {
    elem.attr("href", lien_mobile[0]);
  } else {
    elem.removeAttr('href');
  }

  text_mobile ? elem.html(text_mobile[0]) : null;
  setInterval(_change, 3000);
}
'use strict';

if (window.matchMedia("(max-width: 767px)").matches) {
  $('#sidebar-accordion-footer .plus__icon').show();
  $('#sidebar-accordion-footer').find('li.extend').click(function (e) {
    $(this).children('.extended-submenu').slideToggle('fast');
    $(this).children('.nav__footer--title').children('.plus__icon').toggleClass('opened');
    $(this).toggleClass('active');
  });
}

$(window).on('resize', function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('#sidebar-accordion-footer .extended-submenu').hide();
  }
  if (window.matchMedia("(min-width: 768px)").matches) {
    $('#sidebar-accordion-footer .extended-submenu').show();
  }
});
"use strict";

var pageOverlayOpened = false;
$(".navigation__item--link-megamenu, .navigation__item--images-megamenu").mouseenter(function () {
  if ($("#navigation--container").hasClass('filter-drawer-open')) {
    $('#filter-collection-drawer').removeClass('opened');
    $('#page__overlay-filter').removeClass('opened');
    if ($(document).scrollTop() < 20) {
      $("#navigation--container").addClass('transparent--nav');
      $("#navigation--container").removeClass('scrolled--nav filter-drawer-open');
    } else {
      $("#navigation--container").removeClass('filter-drawer-open');
    }
    $('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav').removeClass('filter-open');
  }
  if (pageOverlayOpened == false) {
    $('#page__overlay--navigation').addClass('opened');
    pageOverlayOpened = true;
  }
});

$(".navigation__item--link-megamenu, .navigation__item--images-megamenu").mouseleave(function () {
  if (pageOverlayOpened == true) {
    $('#page__overlay--navigation').removeClass('opened');
    pageOverlayOpened = false;
  }
});
'use strict';

var whiteNavBar = function whiteNavBar() {
  $('#homepage--link .icon--flowrette-footer').removeClass('logo--white');
  $('.navigation__item--desktop').removeClass('white');
  $('#icon-notif .icon--notif').removeClass('logo--white');
  $('#icon-account .icon--account').removeClass('logo--white');
  $('#icon-cart .icon--cart').removeClass('logo--white');
  $('#icon-search .icon--recherche').removeClass('logo--white');
  $('#icon-underline .icon--soulignement').removeClass('logo--white');
  $('.left-desktop--container .icon--tiktok').removeClass('logo--white');
  $('.left-desktop--container .icon--instagram').removeClass('logo--white');
  $('.left-desktop--container .icon--pinterest').removeClass('logo--white');
  $('.left-desktop--container .icon--facebook').removeClass('logo--white');
  $('#icon-search').removeClass('search-white');
  $('#icon-search .icon--search').removeClass('logo--white');
  $('#icon-search .text-search').removeClass('white');
  $('#icon-notif-device .icon--notif').removeClass('logo--white');
  $('#icon-account-device .icon--account').removeClass('logo--white');
  $('#icon-cart-device .icon--cart').removeClass('logo--white');
  $('#icon-search-mobile .icon--search').removeClass('logo--white');
  $('.menu-mobile .icon--nav').removeClass('logo--white');
  $('.site-header__section--switcher, .swicth-new--container, .market--switcher').removeClass('logo--white');
};

var transparentNavbar = function transparentNavbar() {
 
  $('#homepage--link .icon--flowrette-footer').addClass('logo--white');
  $('.navigation__item--desktop').addClass('white');
  $('#icon-notif .icon--notif').addClass('logo--white');
  $('#icon-account .icon--account').addClass('logo--white');
  $('#icon-cart .icon--cart').addClass('logo--white');
  $('#icon-search .icon--recherche').addClass('logo--white');
  $('.left-desktop--container .icon--tiktok').addClass('logo--white');
  $('.left-desktop--container .icon--instagram').addClass('logo--white');
  $('.left-desktop--container .icon--pinterest').addClass('logo--white');
  $('.left-desktop--container .icon--facebook').addClass('logo--white');
  $('#icon-search').addClass('search-white');
  $('#icon-search .icon--search').addClass('logo--white');
  $('#icon-search .text-search').addClass('white');
  $('#icon-notif-device .icon--notif').addClass('logo--white');
  $('#icon-account-device .icon--account').addClass('logo--white');
  $('#icon-cart-device .icon--cart').addClass('logo--white');
  $('#icon-search-mobile .icon--search').addClass('logo--white');
  $('.menu-mobile .icon--nav').addClass('logo--white');
  $('.site-header__section--switcher, .swicth-new--container, .market--switcher').addClass('logo--white');
};

var handleBarChange = function handleBarChange() {
  if ($("body.template-index #navigation--container").hasClass('fixedWhiteNav') == false) {
    
    $("body.template-index #navigation--container").addClass('transparent--nav');

    transparentNavbar();
  }
};

var gestionScrollTransparent = function gestionScrollTransparent() {
  if ($(document).scrollTop() < 20) {
   $("body.template-index #shopify-section-navigation--logo-center").addClass('headersticky');



  } else {
    $("body.template-index #navigation--container").removeClass('transparent--nav');
    $("body.template-index #navigation--container").addClass('scrolled--nav');
    
      whiteNavBar()

  }

if(!$('body').hasClass('template-index')){
  whiteNavBar()
}
  $(document).on('scroll', function () {
    if ($(document).scrollTop() > 20) {
      $("body.template-index #navigation--container").removeClass('transparent--nav');
      $("body.template-index  #navigation--container").addClass('scrolled--nav');
      whiteNavBar();
         $("body.template-index  #shopify-section-navigation--logo-center").removeClass('headersticky');
      $('body.template-index #navigation--container').mouseleave(function () {
        whiteNavBar();
      });
    } else {
     
      if($('body').hasClass('template-index')){
         handleBarChange();
           $("body.template-index #shopify-section-navigation--logo-center").addClass('headersticky');
      $("body.template-index  #navigation--container").removeClass('scrolled--nav');
      }
   
      $('body.template-index  #navigation--container').mouseleave(function () {
        handleBarChange();
      });
    }
  });
};

// if (window.location.pathname == "/" || window.general.headerTransparent == 1) {
//   if (window.location.href.indexOf("product") > -1) {
//     if (window.matchMedia("(min-width: 1101px)").matches) {

//       if ($(document).scrollTop() < 20) {
//         if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
//           $("#navigation--container").addClass('transparent--nav');
//         }
//         $('#navigation--container').mouseenter(function () {
//           $(this).removeClass('transparent--nav');
//         });

//         $('#navigation--container').mouseleave(function () {
//           if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
//             $("#navigation--container").addClass('transparent--nav');
//           }
//         });
//       }

//       if ($(document).scrollTop() > 20) {
//         $("#navigation--container").removeClass('transparent--nav');
//         $("#navigation--container").addClass('scrolled--nav');
//       }

//       $(document).on('scroll', function () {
//         if ($(document).scrollTop() > 20) {
//           $("#navigation--container").removeClass('transparent--nav');
//           $("#navigation--container").addClass('scrolled--nav');
//         } else {
//           if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
//             $("#navigation--container").addClass('transparent--nav');
//           }
//           $("#navigation--container").removeClass('scrolled--nav');

//           $('#navigation--container').mouseleave(function () {
//             if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
//               $("#navigation--container").addClass('transparent--nav');
//             }
//           });
//         }
//       });
//     }
//   } else {
//     gestionScrollTransparent();
//   }
// }
 gestionScrollTransparent();
// Gestion du scroll
if (window.matchMedia("(max-width: 1100px)").matches) {
  if ($(document).scrollTop() > 20) {
    $('#navigation__drawer').addClass('scroll-drawer');
  } else {
    $('#navigation__drawer').removeClass('scroll-drawer');
  }
  $(document).on('scroll', function () {
    if ($(document).scrollTop() > 20) {
      $('#navigation__drawer').addClass('scroll-drawer');
    } else {
      $('#navigation__drawer').removeClass('scroll-drawer');
    }
  });
}

var scrollNavDrawer = function scrollNavDrawer() {
  if ($(document).scrollTop() > 20) {
    var navbarFilterDesktop = 97;
    var navbarFilterMobile = 59;
  } else {
    var navbarFilterDesktop = 137;
    var navbarFilterMobile = 99;
  }

  if (window.matchMedia("(max-width: 1100px)").matches) {
    $('#filter-collection-drawer').css('height', window.innerHeight - navbarFilterMobile);
    $('#filter-collection-drawer').css('top', navbarFilterMobile + 'px');
  } else {
    $('#filter-collection-drawer').css('height', window.innerHeight - navbarFilterDesktop);
    $('#filter-collection-drawer').css('top', navbarFilterDesktop + 'px');
  }

  // var heightContainerFilter = $('#filter-collection-drawer').height();
  // var heightHeaderFilter = $('.header-filter--container').outerHeight(true);
  // var stickyBoutonFilter = $('.sticky-filter--container').outerHeight(true);
  // $('.filter-form').css('max-height', heightContainerFilter - heightHeaderFilter - stickyBoutonFilter);
  // $('.filter-form').css('height', heightContainerFilter - heightHeaderFilter - stickyBoutonFilter);
};

scrollNavDrawer();

$(document).on('scroll', function () {
  scrollNavDrawer();
});


"use strict";

if (window.location.href.indexOf("blog") > -1 || window.location.href.indexOf("article") > -1 || window.location.href.indexOf("journal") > -1) {
  $('#icon-search-blog, #icon-search-blog-2').on('click', function () {
    if ($('.search--container').hasClass('opened-blog')) {
      $('.search--container').removeClass('opened-blog');
      $('.searchArticle').val('');
      $(".result-search").html('');
    } else {
      $('.search--container').addClass('opened-blog');
      $('.searchProduct.search--input').focus();
    }
  });

  var handleCloseSearch = function handleCloseSearch() {
    $('.searchArticle').val('');
    $(".result-search").html('');
    $('.search--container').removeClass('opened-blog');
    $('.search--container').css('transform', '');
  };

  $('.close--search').on('click', function () {
    handleCloseSearch();
  });

  $(document).on('click', function (e) {

    var container = $(".search--container");
    var container2 = $(".search--container-barre");
    if ($(e.target).hasClass('search--trigger')) {} else {
      if (container.hasClass('opened-blog') && !container.is(e.target) && container.has(e.target).length === 0) {
        handleCloseSearch();
      }
    }

    if (!container2.is(e.target) && container2.has(e.target).length === 0) {
      $('.searchArticle-barre').val('');
      $('.result-search-barre').html('');
    }
  });
} else {
  var handleSearchBar = function handleSearchBar(searchTriggerId, positionScrolledClass, positionClass, translateYScrolled, translateY) {
    $(searchTriggerId).on('click', function () {
      if ($(searchTriggerId).hasClass('filter-open')) {
        $('#filter-collection-drawer').removeClass('opened');
        $('#page__overlay-filter').removeClass('opened');
        if ($(document).scrollTop() < 20) {
          $("#navigation--container").addClass('transparent--nav');
          $("#navigation--container").removeClass('scrolled--nav filter-drawer-open');
        } else {
          $("#navigation--container").removeClass('filter-drawer-open');
        }
        $('.navigation__item--link, .icon--flowrette-footer, .icon--pinterest, .icon--instagram, .icon--tiktok, #icon-search, .icon--search, .text-search, .icon--cart, .icon--account, .icon--notif, .icon--nav').removeClass('filter-open');
      }
      if ($('.search--container').hasClass(positionScrolledClass) || $('.search--container').hasClass(positionClass)) {
        $('#page__overlay--navigation').removeClass('opened');
        $('.navigation__item--container').removeClass('search--opened');
        $('#navigation--container').removeClass('fixedWhiteNav');
        $('.search--container').removeClass(positionScrolledClass + " " + positionClass);
        $('.search--container').css('transform', '');
        $('.searchProduct').val('');
        $(".result-search").html('');
        $(".popular_product").hide();
      } else {
        $('#page__overlay--navigation').addClass('opened');
        $('.navigation__item--container').addClass('search--opened');
        //$('#navigation--container').addClass('fixedWhiteNav');
        $('#navigation--container').removeClass('transparent--nav');
        $(".popular_product").show();
        if ($(document).scrollTop() >= 20) {
          $('.search--container').addClass(positionScrolledClass);
        } else {
          var topPosition = translateY - $(document).scrollTop();
          $('.search--container').addClass(positionClass);
          $(".search--container." + positionClass + ", .search--container." + positionScrolledClass).css('transform', "translateY(" + topPosition + "px)");
        }
        $('.searchProduct').focus();
      }
      $('.searchProduct.search--input').focus();
    });

    $(document).on('scroll', function () {
      if ($(document).scrollTop() >= 20) {
        $(".search--container." + positionClass + ", .search--container." + positionScrolledClass).css('transform', "translateY(" + translateYScrolled + "px)");
      } else {
        var topPosition = translateY - $(document).scrollTop();
        $(".search--container." + positionClass + ", .search--container." + positionScrolledClass).css('transform', "translateY(" + topPosition + "px)");
      }
    });
  };

  if (window.matchMedia("(max-width: 767px)").matches) {
    handleSearchBar('#icon-search-mobile', 'opened-mobile-scroll', 'opened-mobile2', 0, 0);
    handleSearchBar('.search-nav-drawer', 'opened-mobile-scroll', 'opened-mobile2', 0, 0);
    $('.search-nav-drawer').on('click', function () {
      $('#navigation__drawer').removeClass('opened');
      $("#page__overlay[for='drawer']").removeClass('opened');
    });
  } else if (window.matchMedia("(max-width: 1150px)").matches) {
    handleSearchBar('#icon-search-mobile', 'opened-mobile-scroll', 'opened-mobile', 0, 0);
    handleSearchBar('.search-nav-drawer', 'opened-mobile-scroll', 'opened-mobile', 0, 0);
    $('.search-nav-drawer').on('click', function () {
      $('#navigation__drawer').removeClass('opened');
      $("#page__overlay[for='drawer']").removeClass('opened');
    });
  } else {
    handleSearchBar('#icon-search', 'opened-scroll', 'opened', 0, 0);
  }

  var handleCloseSearch = function handleCloseSearch() {
    $('.searchProduct').val('');
    $(".result-search").html('');
    $('.search--container').removeClass('opened opened-scroll opened-mobile-scroll opened-mobile opened-mobile2');
    $('.search--container').css('transform', '');
    $('#navigation--container').removeClass('fixedWhiteNav');
    $('#page__overlay--navigation').removeClass('opened');
    $('.navigation__item--container').removeClass('search--opened');
    $('html, body').css({ overflow: 'visible' });
  };

  $('.close--search').on('click', function () {
    handleCloseSearch();
  });

  $(document).on('click', function (e) {

    var container = $(".search--container");
    if ($(e.target).hasClass('search--trigger')) {} else {
      if ((container.hasClass('opened') || container.hasClass('opened-mobile')) && !container.is(e.target) && container.has(e.target).length === 0) {
        handleCloseSearch();
      }
    }
  });

  $(document).on('click', '.global-search', function () {
    //var url = window.location.hostname
    var search = document.getElementsByClassName('searchProduct')[0].value;
    var redirection = "/search?type=product&q=" + search;
    window.location.replace(redirection);
    $('.search--container').removeClass('opened');
  });
}

$(document).on('input', '.search--input', function () {
  if ($(this).attr('search') === 'barre') {
    SearchFunction('searchArticle-barre', 'article', 'result-search-barre');
  } else if ($(this).attr('search') === 'article') {
    SearchFunction('searchArticle', 'article', 'result-search');
  } else if ($(this).attr('search') === 'produit') {
    SearchFunction('searchProduct', 'product', 'result-search');
  }
});

var SearchFunction = function SearchFunction(classInput, typeSearch, classInputResult) {

  var htmlItem = function htmlItem(type, item) {
    if (type == "article") {
      return "<div class='one-product article'><a class='flex fd--row jc--flex-start' href=" + item[i].url + "><img class='image-product' src=" + item[i].image + "><div class='content--container flex fd--column ai--flex-start'><p class='price--grid white product--title'>" + item[i].title + "</p></div></a></div>";
    } else {
      if (item[i].compare_at_price_max == 0.00) {
        var prix = item[i].price.replace('.', ',') + '€';
      } else {
        var prix = item[i].price.replace('.', ',') + "€<span class='reduction line__through '>" + item[i].compare_at_price_max.replace('.', ',') + "€</span>";
      }
      return " <div class='one-product'><a class='flex fd--row jc--flex-start' href=" + item[i].url + "><img class='image-product' src=" + item[i].image + "><div class='content--container flex fd--column ai--flex-start'><p class='body--text white' style='font-size: 14px; line-height: initial;'>" + item[i].type + "</p><p class='price--grid white product--title'>" + item[i].title + "</p></div></a></div>";
    }
  };

  var emptyItem = function emptyItem(type) {
    if (type == "article") {
      return "<div class='empty'>Aucun article ne correspond à votre recherche</div>";
    } else {
      return "<div class='empty'>Aucun produit ne correspond à votre recherche</div>";
    }
  };

  var q = document.getElementsByClassName(classInput)[0].value;
  var b = "&resources[type]=" + typeSearch;
  var c = '';
  if (q == "") {
    $(".result-search").html('');
    $(".result-search-barre").html('');
  }
  if (typeSearch == 'article') {
    var type = "article";
  } else {
    var type = "product";
    c = '&fields=title,product_type,tag';
    if (q == "") {
      $(".popular_product").show();
    } else {
      $(".popular_product").hide();
    }
  }
  $.ajax('/search/suggest.json?q=' + q + b + c, {
    type: 'GET',
    dataType: 'json',
    success: function success(response) {
      var itemsSuggestions = response.resources.results[typeSearch + "s"];
      if (itemsSuggestions.length > 0) {
        var result = "";
        for (i = 0; i < itemsSuggestions.length; i++) {
          if (itemsSuggestions[i].id != 6623214993579 && itemsSuggestions[i].id != 6623216205995) {
            result += htmlItem(type, itemsSuggestions);
          }
        }

        if (type == "product") {
          result = result + "<div class='global-search'>Plus de résultats</div>";
        }
        $("." + classInputResult).css('margin-bottom', '20px');
        $("." + classInputResult).css('padding-top', '40px');
        $("." + classInputResult).html(result);
      } else {
        var emptyProduct = emptyItem(type);
        $("." + classInputResult).css('margin-bottom', '');
        $("." + classInputResult).css('padding-top', '');
        $("." + classInputResult).html(emptyProduct);
      }
    },
    error: function error(_error) {
      $("." + classInputResult).css('margin-bottom', '');
      $("." + classInputResult).css('padding-top', '');
    }
  });
};
'use strict';

//four collection
$('.title-collection').on('click', function () {
    if ($(this).hasClass('is-active')) {} else {
        $('.title-collection').removeClass('is-active');
        $(this).addClass('is-active');
        var forCollection = $(this).attr('for');
        $('.collection-product').addClass('display__none');
        $('.' + forCollection).removeClass('display__none');
    }
});

$(window).on('load', function () {
    for (i = 0; i < 3; i++) {
        var heightFirstDiv = $('.left-four-collection-' + i).outerHeight(true);
        $('.right-four-collection-' + i).css('max-height', heightFirstDiv);
    }
    if (window.location.href.indexOf("product") > -1) {
        var heightFirstDiv = $('.left-four-collection-').outerHeight(true);
        $('.right-four-collection-').css('max-height', heightFirstDiv);
    }
});

//product fav
$('.one-variant').on('click', function () {
    var variantID = $(this).attr('variant-id');
    var available = $(this).attr('available');
    var price = $(this).attr('price');
    var image = $(this).attr('image');

    $('.price-product-fav').text(price);

    $('.image-product-fav').attr('src', image);

    $('.one-variant').removeClass('is-actived');
    $(this).addClass('is-actived');

    $('.button-product-fav').attr('variant-id', variantID).attr('variant-available', available);
    if (available == 'false') {
        $('.button-product-fav').text('Rupture de stock');
    } else {
        if (window.theme.language == 'en') {
            $('.button-product-fav').text('Add to cart');
        } else {
            $('.button-product-fav').text('Ajouter au panier');
        }
    }
});

var heightReviewContainer = $('.review-client-height').outerHeight(true);
$('.image-review-client').css('max-height', heightReviewContainer);
'use strict';

//footer
$(window).on('resize', function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('#sidebar-accordion-footer .extended-submenu').hide();
  }
});

// Gestion des boutons
$('.button__with__loading').on('click', function () {
  if ($(this).hasClass('button-commander')) {
    var date = $('.pickadate').val();
    if (date != '') {
      $(this).children('.button--text, .subtitle--text').hide();
      $(this).children('.button--loading').css('display', 'flex');
    }
  } else {
    $(this).children('.button--text, .subtitle--text').hide();
    $(this).children('.button--loading').css('display', 'flex');
  }
});

// Si go back --> on remet les boutons en mode texte
window.addEventListener("pageshow", function (event) {
  var historyTraversal = event.persisted || typeof window.performance != "undefined" && window.performance.navigation.type === 2;
  if (historyTraversal) {
    $('.button__with__loading').children('.button--text').show();
    $('.button__with__loading').children('.button--loading').css('display', 'none');
  }
});

$('.form--to-validate .form-field').on('invalid', function () {
  $('.form--to-validate .button--text').show();
  $('.form--to-validate .button--loading').css('display', 'none');
});

function deferSrcImages(className) {
  var imgDefer = document.getElementsByClassName(className);
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('defer-src')) {
      imgDefer[i].setAttribute('src', imgDefer[i].getAttribute('defer-src'));
    }
  }
}

function deferSrcPoster(className) {
  var imgDefer = document.getElementsByClassName(className);
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('defer-poster')) {
      imgDefer[i].setAttribute('poster', imgDefer[i].getAttribute('defer-poster'));
    }
  }
}

function deferSrcsetImages(className) {
  var imgDefer = document.getElementsByClassName(className);
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('defer-srcset')) {
      imgDefer[i].setAttribute('srcset', imgDefer[i].getAttribute('defer-srcset'));
    }
  }
}

window.onload = function () {
  document.dispatchEvent(new CustomEvent('update-reco-drawer'));
  renderCart();

  deferSrcsetImages("source--product");
  setTimeout(function () {
    deferSrcImages("defer--product");
  }, 200);
  if (window.matchMedia("(max-width: 1100px)").matches) {
    deferSrcImages("defer--image-m");
  } else {
    deferSrcImages("defer--image-d");
  }

  // Sur mobile, on rafraichit la hauteur des drawers au chargement
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('#cart__drawer, #drawer__cart--exta-infos, #navigation__drawer').css('height', window.innerHeight);
    $('#cart__drawer, #drawer__cart--exta-infos, #navigation__drawer').css('max-height', window.innerHeight);
  }
};

// Gestion de la hauteur des drawers au scroll
$(document).on('scroll', function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('#cart__drawer, #drawer__cart--exta-infos, #navigation__drawer').css('height', window.innerHeight);
    $('#cart__drawer, #drawer__cart--exta-infos, #navigation__drawer').css('max-height', window.innerHeight);
  }
});

// Bloc SEO
$('#show').click(function () {
  $('.max__height--seo').css("max-height", '1000px');
  $(this).hide();
  $('#hide').show();
});
$('#hide').click(function () {
  $('.max__height--seo').css("max-height", '80px');
  $(this).hide();
  $('#show').show();
});

if (window.matchMedia("(min-width: 767px)").matches) {
  $(window).on('load', function () {
    $(".product__item--container").hover(function () {
      $(this).children('.product__item__div--hover').addClass('hover');
    }, function () {
      $(this).children('.product__item__div--hover').removeClass('hover');
    });
  });
}
if (window.location.href.indexOf("blog") > -1 || window.location.href.indexOf("article") > -1 || window.location.href.indexOf("journal") > -1 || window.location.href.indexOf("/cart") > -1) {} else {
  var type = function type(string, element) {
    (function writer(i) {
      if (string.length <= i++) {
        element.textContent = string;
        return;
      }
      element.textContent = string.substring(0, i);
      var rand = Math.floor(Math.random() * 200);
      setTimeout(function () {
        writer(i);
      }, rand);
    })(0);
  };
  // TO_ACTIVATE


  var text = window.general.searchText;
  var ta = document.getElementById("text-search");
  type(text, ta);
}

$('.one-ancre').on('click', function () {
  var id = $(this).attr('href');
  $('html, body').animate({
    scrollTop: $(id).offset().top - 70
  }, 500);
});

$(window).on('load', function () {
  document.dispatchEvent(new CustomEvent('update-reco-drawer'));
});

var pathname = window.location.pathname;
var langCode = pathname.split("/");
console.log(langCode[1]);
if (langCode[1] == 'en') {
  $('#homepage--link, .button-eShop').attr('href', '/en');
  $('.icon-logo-blog').attr('href', '/en/pages/journal');
  $('#checkout--button').attr('href', '/en/checkout');
} else if (langCode[1] == 'de') {
  $('#homepage--link, .button-eShop').attr('href', '/de');
  $('.icon-logo-blog').attr('href', '/de/pages/journal');
  $('#checkout--button').attr('href', '/de/checkout');
} else if (langCode[1] == 'es') {
  $('#homepage--link, .button-eShop').attr('href', '/es');
  $('.icon-logo-blog').attr('href', '/es/pages/journal');
  $('#checkout--button').attr('href', '/es/checkout');
} else if (langCode[1] == 'it') {
  $('#homepage--link, .button-eShop').attr('href', '/it');
  $('.icon-logo-blog').attr('href', '/it/pages/journal');
  $('#checkout--button').attr('href', '/it/checkout');
}

$('.click-market').on('click', function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $(this).find('.icon-arrow-switcher').removeClass('opened');
    $('.dropdown-markets').addClass('display__none');
  } else {
    $(this).addClass('active');
    $(this).find('.icon-arrow-switcher').addClass('opened');
    $('.dropdown-markets').removeClass('display__none');
  }
});
'use strict';

$('#go-top').on('click', function () {
  $('html, body').animate({
    scrollTop: 0
  }, 500);
});

if ($(document).scrollTop() > 20) {
  $('#go-top').show();
} else {
  $('#go-top').hide();
}

$(document).on('scroll', function () {
  if ($(document).scrollTop() > 20) {
    $('#go-top').show();
  } else {
    $('#go-top').hide();
  }
});
'use strict';

var displayPrice = function displayPrice(price) {
  return price / 100 + '€';
};
'use strict';

$('.newsletter-form').submit(function (e) {
  e.preventDefault();
  /*if ($('#checkbox--newsletter').hasClass('checked')) {
    $('.checkbox--email').hide()*/
  var index = $(this).attr('form-index');
  var email = $('.email--newsletter[form-index="' + index + '"]').val().toLowerCase();
  var fields = "$source,$email,$consent";

  var formData = {
    "email": email,
    "g": $('.list--newsletter[form-index="' + index + '"]').val(), // liste klaviyo
    "$consent": "email",
    "$source": $('.newsletter-form[form-index="' + index + '"]').attr('source'),
    "$fields": fields
  };

  $.ajax({
    type: "POST",
    url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
    data: formData,
    dataType: 'json',
    success: function success(response) {
      if (response.errors && response.errors.length > 0) {
        $('.newsletter-form .error--email').show();
        _learnq.push(['identify', {
          '$email': email
        }]);
      } else {
        $('.newsletter-form .success--email').show();
      }
    },
    error: function error(_error) {
      $('.newsletter-form .error--email').show();
    }
  });
  /*} else {
    $('.checkbox--email').show()
  }*/
});

$('#checkbox--newsletter').on('click', function () {
  if ($(this).hasClass('checked')) {
    $(this).removeClass('checked');
  } else {
    $(this).addClass('checked');
  }
});
'use strict';

$('body').on('click', '.atc', function () {
  var attribute = $(this).attr("data-atc");
  if (event.ctrlKey || $(this).hasClass('atc_blank')) {
    var newWindow = window.open(decodeURIComponent(window.atob(attribute)), '_blank');
    newWindow.focus();
  } else {
    document.location.href = decodeURIComponent(window.atob(attribute));
  }
});
'use strict';

$('.faq__q__and__a').on('click', function () {
  $('.arrow-bottom').attr('arrow-open', 'false');
  var $question = $(this).children('.faq__question');
  $('.plus__icon').removeClass('opened');
  $question.children('.plus__icon').toggleClass('opened');
  if ($question.next().attr('aria-hidden') == 'false') {
    $question.next().slideToggle(200).attr('aria-hidden', 'true');
    $(this).find('span').attr('arrow-open', 'false');
    $('.plus__icon').removeClass('opened');
  } else {
    $('.faq__q__and__a').find('.faq__answer[aria-hidden="false"]').not($question).slideToggle(200).attr('aria-hidden', 'true');
    $question.next().slideToggle(200).attr('aria-hidden', 'false');
    $(this).find('span').attr('arrow-open', 'true');
  }
});

$('.question').on('click', function () {
  $('.arrow-bottom').attr('arrow-open', 'false');
  if ($(this).next().attr('aria-hidden') == 'false') {
    $(this).next().slideToggle(200).attr('aria-hidden', 'true');
    $(this).find('span').attr('arrow-open', 'false');
  } else {
    $('.faq--container').find('.faq__answer[aria-hidden="false"]').not(this).slideToggle(200).attr('aria-hidden', 'true');
    $(this).next().slideToggle(200).attr('aria-hidden', 'false');
    $(this).find('span').attr('arrow-open', 'true');
  }
});

$('.picto__container').on('click', function () {
  $('.picto__container').removeClass('is-active');
  $(this).addClass('is-active');
  var number = $(this).attr('data-separator');
  $('.faq--container.is-opened').removeClass('is-opened is-visible');
  $('.faq--container[data-separator=' + number + ']').addClass('is-opened');
  setTimeout(function () {
    $('.faq--container[data-separator=' + number + ']').addClass('is-visible');
  }, 10);
  $('html, body').animate({
    scrollTop: $('.scroll-div-faq').offset().top - 70
  }, 500);
});
"use strict";
'use strict';

$('#close-article-page').on('click touchend', function () {
  $('#article-page-overlay').hide();
});
$(document).mouseup(function (e) {
  var container = $("#article-page");
  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('#article-page-overlay').hide();
  }
});
$('.article').on('click touchend', function () {
  var background_url = "https:" + $(this).attr('background-img');
  $('#click-contain img').attr('src', background_url);
  $('#article-page-overlay').show().css('display', 'flex');
});
'use strict';

$('ul.sidebar-accordion').find('li.extend').click(function () {
  $('li.extend.active').not($(this)).toggleClass('active');
  //Expand or collapse this panel
  $(this).next().slideToggle('fast');
  $(this).toggleClass('active');
  //Hide the other panels
  $("ul.extended-submenu").not($(this).next()).slideUp('fast');
});

$('#moreDetails').on('click', function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('html, body').animate({
      scrollTop: $(".ProductDescription--mobile-container").offset().top - 140
    }, 600);
  } else {
    $('html, body').animate({
      scrollTop: $(".ProductDescription").offset().top - 200
    }, 600);
  }
});

$('.tabs').each(function () {
  var active,
      content,
      links = $(this).find('a');
  active = links.first().addClass('active');
  content = $(active.attr('href'));
  links.not(':first').each(function () {
    $($(this).attr('href')).hide();
  });
  $(this).find('a').click(function (e) {
    active.removeClass('active');
    content.hide();
    active = $(this);
    content = $($(this).attr('href'));
    active.addClass('active');
    content.show();
    return false;
  });
});

$('#details__anchor').on('click', function () {
  var id = $(this).attr('href');

  $('html, body').animate({
    scrollTop: $(id).offset().top - 150
  }, 500);
});
'use strict';

$('#slider--product').slick({
  dots: false,
  infinite: true,
  arrows: true,
  prevArrow: prevArrow,
  nextArrow: nextArrow,
  waitForAnimate: false,
  variableWidth: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
      {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        variableWidth: false,
        arrows: true,
        prevArrow: '<span class="slick-arrow--left"><svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.25 7.25L0.75 4L4.25 0.75" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
        nextArrow: '<span class="slick-arrow--right"><svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 0.75L4.25 4L0.75 7.25" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
      }
    }
  ]
});

$('#slider--product').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  $('#slider__nav--product .carousel-cell').removeClass('is-nav-selected');
  $('#slider__nav--product .carousel-cell[thumb-index="' + nextSlide + '"]').addClass('is-nav-selected');
});

$('body').on('click', '.carousel-cell-thumb', function () {
  var index = $(this).attr('thumb-index');
  $('#slider__nav--product .carousel-cell').removeClass('is-nav-selected');
  $(this).addClass('is-nav-selected');
  $('#slider--product').slick('slickGoTo', index);
});
'use strict';

var productDetails = {};
if ($('[product-details]').html()) {
  productDetails = JSON.parse($('[product-details]').html());
}

$('.quantity__change--selector-product').on('click', function () {
  var type = $(this).attr('type');
  var currentQty = parseInt($('.product__qty--container .quantity__current').val());

  if (type == 'minus') {
    if (currentQty != 0) {
      $('.product__qty--container .quantity__current').val(currentQty - 1);
    }
  } else {
    $('.product__qty--container .quantity__current').val(currentQty + 1);
  }
});

document.addEventListener('select-changed:product__option--1', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);
document.addEventListener('select-changed:product__option--2', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);
document.addEventListener('select-changed:product__option--3', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);

var loadButton = function loadButton() {
  var price = $('.image-variant.active-variant').attr('variant-price');
  var variantId = $('.image-variant.active-variant').attr('variant-id') 
  var available = $('.image-variant.active-variant').attr('variant-available');
  var productId = $('.image-variant.active-variant').attr('product-id');

  // if(!variantId){
  // variantId=   $('.product__description--container .bulle__custom--value.is__active .cart--variant-price').data('variantid');
  // }
  // if(!productId){
  //     var productId = $('.product-form-submit').attr('product-id');
  // }

  if (available == "false") {
    $('.add__to__cart[product-id="' + productId + '"]').html('<span class="text__center subtitle--text white">\n          Rupture de stock\n        </span>');
    $('.add__to__cart[product-id="' + productId + '"]').attr('id', 'BIS_trigger');
    $('.add__to__cart[product-id="' + productId + '"]').attr('variant-available', false);
    $('.add__to__cart[product-id="' + productId + '"]').attr('data-variant-id', variantId);
  } else {
    $('.quantity-dropdown').attr('product-price', price);

    var newprice = price / 100 + "€";
    $('.add__to__cart.product-form-submit[product-id="' + productId + '"]').html('Ajouter au panier<span class="ph--10 ff subtitle--text white">-</span><span class="product--price-product subtitle--text white">' + newprice + ' </span>');
    $('.add__to__cart.product-form-submit[product-id="' + productId + '"]').attr('id', '');
    $('.add__to__cart.product-form-submit[product-id="' + productId + '"]').attr('variant-available', true);
    $('.add__to__cart.product-form-submit[product-id="' + productId + '"]').attr('variant-id', variantId);
  }
};

// Change variant for bulles
$('.bulle__custom--value').on('click', function (e) {
     var value =e.currentTarget.dataset.value;
  var option = $(this).attr('for');
  console.log("option",option)
  $('.image-infos-variant--container').addClass('display__none');
  $('.image-infos-variant--container[option-taille=' + value + ']').removeClass('display__none');
  $('.image-variant').removeClass('active-variant');
  setTimeout(function () {
    $('.image-infos-variant--container[option-taille="' + value + '"] .image-variant[option-product="Non"]').click();
  }, 10);
  $('.image-variant[option-product=Non]').addClass('active-variant');

  var newPrice = $('.image-variant[option-taille=' + value + '][option-product=Non]').attr('variant-price');
  $('.quantity-dropdown').attr('product-price', newPrice);
  $('.product__qty--container .quantity__current').attr('value', 1);

  $('.select__custom--selected-value[for="' + option + '"]').text(value);
  $('.bulle__custom--value[for="' + option + '"]').removeClass('is__active');
  $(this).addClass('is__active');

  document.dispatchEvent(new CustomEvent('select-changed:' + option, { 'detail': { quickAdd: "false" } }));

  loadButton();
});

function updateProductButton(variant, productId) {
  var price = parseFloat(variant.price.replace('€', ''));
  var compareAtPrice = parseFloat(variant.compareAtPrice.replace('€', ''));
  if (variant.available == 0) {
    /*$(`.add__to__cart[product-id="${productId}"]`).html(`<span class="text__center subtitle--text  white">
          Rupture de stock
        </span>`)
    $(`.add__to__cart[product-id="${productId}"]`).attr('id', 'BIS_trigger');
    $(`.add__to__cart[product-id="${productId}"]`).attr('variant-available', false);
    $(`.add__to__cart[product-id="${productId}"]`).attr('data-variant-id', variant.id);*/
    $('.available-product--container').hide();
    $('.notify_form').addClass('display-notify');
  } else {
    $('.available-product--container').show();
    $('.notify_form').hide().removeClass('display-notify');
    $('.add__to__cart.product-form-submit[product-id="' + productId + '"]').attr('id', '');
    $('.add__to__cart.product-form-submit[product-id="' + productId + '"]').attr('variant-available', true);
    var addCart = '';
    if (window.theme.language == 'en') {
      addCart = 'Add to cart';
    } else if (window.theme.language == 'de') {
      addCart = 'in den Warenkorb legen';
    } else if (window.theme.language == 'es') {
      addCart = 'Añadir a la cesta';
    } else if (window.theme.language == 'it') {
      addCart = 'Aggiungi al carrello';
    } else {
      addCart = 'Ajouter au panier';
    }
    if (compareAtPrice > price) {
      $('.add__to__cart.product-form-submit[product-id="' + productId + '"]').html(addCart + '<span class="ph--10  subtitle--text white">-</span><span class="product--price-product subtitle--text white" >' + variant.price + '</span>');
    } else {
      $('.add__to__cart.product-form-submit[product-id="' + productId + '"]').html(addCart + '<span class="ph--10  subtitle--text white">-</span><span class="product--price-product subtitle--text white">' + variant.price + '</span>');
    }
  }
}

function onOptionChanged() {
  var productOptions = [];


for (var i = 1; i <= 3; i++) {
    productOptions[i - 1] = $('.select__custom--selected-value[product-id="' + productDetails.productId + '"][name="product__option--' + i + '"]').text().trim() || "";
  }
  if (productDetails && productDetails.variants.length > 1) {
    productDetails.variants.forEach(function (variant) {
      if (variant.option1 == productOptions[0] && variant.option2 == productOptions[1] && variant.option3 == productOptions[2]) {
const compareAtPrice = parseFloat(variant.compareAtPrice.replace(' €', '').replace(',', '.'));
const price = parseFloat(variant.price.replace(' €', '').replace(',', '.'));

// Calculate sale price and discount percentage
const salePrice = (compareAtPrice - price).toFixed(2);
     
const discountPercentage = Math.ceil((salePrice * 100) / compareAtPrice);;

    
        const discountPrice = !isNaN(discountPercentage)? `-${discountPercentage}%`:"";
        $('.product-form-submit .product--price-product, .value-product-banner, .price-product').html(variant.price);
        $('.product--compare-at-price, .compare-price-product').html(variant.compareAtPrice);
        if(!isNaN(discountPercentage)){
           $('.product--compare-at-price, .sales__tag--container  ').show();
               $('.product--compare-at-price, .sales__tag--container .text__center ').html(discountPrice);
        }
        else{
             $('.product--compare-at-price, .sales__tag--container  ').hide();
  
               $('.product--compare-at-price, .sales__tag--container .text__center ').html("");
        }
   
        $('.add__to__cart.product-form-submit[product-id="' + productDetails.productId + '"]').attr('variant-id', variant.id);
        var url = document.location.origin + document.location.pathname + ('?variant=' + variant.id);
        window.history.replaceState({ path: url }, '', url);
        var featuredImage = variant.imageId;

        console.log(featuredImage);

        var imageNumber = parseInt($('#slider--product .product__image[image-id="' + featuredImage + '"]').attr("slide-number"));
      
        if (imageNumber) {
          $('#slider--product').slick('slickGoTo', imageNumber);
        } else if (imageNumber == 0) {
          $('#slider--product').slick('slickGoTo', imageNumber);
        }

        updateProductButton(variant, productDetails.productId);
      }
    });
  }
}

$('.sidebar-accordion-description-product').find('li.extend').click(function (e) {
  
  $(this).children('.extended-submenu').slideToggle('fast');
  $(this).children('.nav__des-product--title').children('.icon--arrow-bottom').toggleClass('opened');
  $(this).children('.nav__des-product--title').children('.body__text--navigation').toggleClass('primary__color--medium').toggleClass('dark__color');
  $(this).toggleClass('active');
});

$('.product__qty--container').on('click', function () {
  if ($(this).children('.icon--arrow-bottom').hasClass('opened')) {
    $(this).children('.icon--arrow-bottom').removeClass('opened');
    $(this).children('.quantity-dropdown--container').hide().removeClass('opened');
  } else {
    $(this).children('.icon--arrow-bottom').addClass('opened');
    $(this).children('.quantity-dropdown--container').show().addClass('opened');
  }
});

$('body').on('click', '.quantity-dropdown', function () {
  var quantity = $(this).attr('value-quantity');
  $('.quantity-dropdown').removeClass('quantity-dropdown-active');
  $(this).addClass('quantity-dropdown-active');
  $('.product__qty--container .quantity__current').attr('value', quantity);
  var oldPrice = $(this).attr('product-price');
  var newPrice = oldPrice * quantity;

  $('.add__to__cart .product--price-product').text(newPrice / 100 + '€');
});

$('body').on('click', '.image-variant', function () {
  var price = $(this).attr('variant-price');
  var compare = $(this).attr('variant-compare');
  var id = $(this).attr('variant-id');
  var image = $(this).attr('link-image');
  var available = $(this).attr('variant-available');
  var productId = $(this).attr('product-id');

  if ('URLSearchParams' in window) {
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set("variant", id);
    var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    history.pushState(null, '', newRelativePathQuery);
  }

  $('.image-variant').removeClass('active-variant');
  $(this).addClass('active-variant');

  if ($('#slider--product .carousel-cell').hasClass('special-image-variant')) {
    $('.special-image-variant .product__image').attr('data-src', image);
    $('.special-image-variant .product__image').attr('src', image);
    if ($('.special-image-variant').hasClass('slick-current')) {} else {
      $('#slider--product').slick('slickGoTo', '.special-image-variant');
    }
  } else {
    $('#slider--product').slick('slickAdd', '<div class="carousel-cell special-image-variant"><img class="lazyload product__image product__image-variant flex mh--10 margin__left--none" data-src="' + image + '" ></div>');
    $('#slider--product').slick('slickGoTo', '.special-image-variant');
  }

  $('.product__qty--container .quantity__current').attr('value', 1);

  if (available == "false") {
    /*$(`.add__to__cart[product-id="${productId}"]`).html(`<span class="text__center subtitle--text white">
          Rupture de stock
        </span>`)
    $(`.add__to__cart[product-id="${productId}"]`).attr('id', 'BIS_trigger');
    $(`.add__to__cart[product-id="${productId}"]`).attr('variant-available', false);
    $(`.add__to__cart[product-id="${productId}"]`).attr('data-variant-id', id);*/
    $('.available-product--container').hide();
    $('.notify_form').addClass('display-notify');
    $('.last-pieces-product').text('Victime de son succès');
  } else {

    var lastPiece = productDetails.numberLastPieces;
    var quantity = $(this).attr('quantity');

    if (quantity < lastPiece) {
      if (window.theme.language == 'en') {
        $('.last-pieces-product').show().text('Attention low stock');
      } else if (window.theme.language == 'de') {
        $('.last-pieces-product').show().text('Warnung niedriger Lagerbestand');
      } else if (window.theme.language == 'es') {
        $('.last-pieces-product').show().text('advertencia de stock bajo');
      } else if (window.theme.language == 'it') {
        $('.last-pieces-product').show().text('Avviso scorta bassa');
      } else {
        $('.last-pieces-product').show().text('Attention stock faible');
      }
    } else {
      $('.last-pieces-product').hide();
    }

    $('.available-product--container').show();
    $('.notify_form').hide().removeClass('display-notify');
    $('.quantity-dropdown').attr('product-price', price);

    var newprice = price / 100 + "€";
    var addCart = '';
    if (window.theme.language == 'en') {
      addCart = 'Add to cart';
    } else if (window.theme.language == 'de') {
      addCart = 'in den Warenkorb legen';
    } else if (window.theme.language == 'es') {
      addCart = 'Añadir a la cesta';
    } else if (window.theme.language == 'it') {
      addCart = 'Aggiungi al carrello';
    } else {
      addCart = 'Ajouter au panier';
    }
    $('.add__to__cart.product-form-submit[product-id="' + productId + '"]').html(addCart + ' - <span class="product--price-product subtitle--text white" style="margin-left: 3px;">' + newprice + '</span>');
    $('.add__to__cart.product-form-submit[product-id="' + productId + '"]').attr('id', '');
    $('.add__to__cart.product-form-submit[product-id="' + productId + '"]').attr('variant-available', true);
    $('.add__to__cart.product-form-submit[product-id="' + productId + '"]').attr('variant-id', id);

    $('.value-product-banner').text(newprice);

    var newPrice2 = (price / 100).toFixed(2) + "€";
    $('.price-product').text(newPrice2);

    if (compare != '') {
      var newCompare = (compare / 100).toFixed(2) + "€";
      $('.compare-price-product').text(newCompare);
    } else {
      $('.compare-price-product').text('');
    }
  }
});

$(document).ready(function () {
  var valueTaille = $('.bulle__custom--value.is__active').attr('value');
  $('.image-variant[option-taille=' + valueTaille + '][option-product=Non]').addClass('active-variant');

  //loadButton()
});

$(document).on('click', function (e) {
  var quantityProduct = $(".product-quantity-click");
  if (quantityProduct.is(e.target)) {} else {
    if ($('.quantity-dropdown--container').hasClass('opened')) {
      $('.quantity-dropdown--container').removeClass('opened').hide();
      $('.icon--arrow-bottom').removeClass('opened');
    }
  }
});

$('body').on('click', '.add-cart-banner', function () {
  var qty = $('.product__qty--container .quantity__current').val();
  var productId = $(this).attr('product-id');
  var variantId = $('.add__to__cart[product-id=' + productId + ']').attr('variant-id');
  var buttonCart = $('.add__to__cart[product-id=' + productId + ']');

  var objUpdate = { quantity: qty, id: variantId };

  if (buttonCart.hasClass('etiquette')) {
    var titre = $('.titre-print').text();
    var sousTitre = $('.sous-titre-print').text();
    var format = $('.print--container').attr('format');
    objUpdate.properties = {
      "Titre": titre,
      "Sous-titre": sousTitre,
      "Format": format
    };
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: objUpdate,
    dataType: 'json',
    success: function success(response) {
      updateCartData();
      renderCart();
      document.dispatchEvent(new CustomEvent('update-reco-drawer'));

      if ($('#empty__cart--title').length > 0) {
        location.reload(true);
      }

      document.dispatchEvent(new CustomEvent('cart:open'));
    }
  });
});

if (window.location.href.indexOf("products") > -1) {
  var scrollThreshold = $(window).width() <= 768 ? 700 : 200;
  
  if ($(document).scrollTop() > scrollThreshold) {
    $('.banner-add-cart--container').addClass('opened');
  } else {
    $('.banner-add-cart--container').removeClass('opened');
  }
  $(document).on('scroll', function () {
    if ($(document).scrollTop() > scrollThreshold) {
      $('.banner-add-cart--container').addClass('opened');
    } else {
      $('.banner-add-cart--container').removeClass('opened');
    }
  });
}

var shippingHolidays = [[1, 1, 2021], [4, 5, 2021], [5, 1, 2021], [5, 8, 2021], [5, 13, 2021], [5, 24, 2021], [7, 14, 2021], [8, 15, 2021], [11, 1, 2021], [11, 11, 2021], [12, 25, 2021], [1, 1, 2022], [4, 18, 2022], [5, 1, 2022], [5, 8, 2022], [5, 26, 2022], [6, 6, 2022], [7, 14, 2022], [8, 15, 2022], [11, 1, 2022], [11, 11, 2022], [12, 25, 2022]];
var processingHolidays = [[1, 1, 2021], [4, 5, 2021], [5, 1, 2021], [5, 8, 2021], [5, 13, 2021], [5, 24, 2021], [7, 14, 2021], [8, 15, 2021], [11, 1, 2021], [11, 11, 2021], [12, 25, 2021], [1, 1, 2022], [4, 18, 2022], [5, 1, 2022], [5, 8, 2022], [5, 26, 2022], [6, 6, 2022], [7, 14, 2022], [8, 15, 2022], [11, 1, 2022], [11, 11, 2022], [12, 25, 2022]];
// cut off time
// format: JSON weekDay => time
var shippingCutOffTime = {
  1: '01:00 PM',
  2: '01:00 PM',
  3: '01:00 PM',
  4: '01:00 PM',
  5: '01:00 PM'
};
var holidays = [
  //   [1, 1, 'fr'],
  //   [10, 20, 'fr'],
  //   [10, 21, 'fr'],
  //   [11, 17, 'fr'],
  //   [11, 20, 'fr']
];
// format: JSON weekDay => time
/* var cutOffTime = {
1: '01:00 PM',
2: '02:00 PM',
3: '03:00 PM',
4: '3:00 PM',
5: '02:34 PM',
}; */
function isHoliday(time) {
  var date = time.getDate();
  var month = time.getMonth() + 1;
  return holidays.some(function (h) {
    return h[0] === month && h[1] === date;
  });
}
Date.prototype.addDays = function (days) {
  var newDate = new Date(this.valueOf());
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};
function isShippingHoliday(time) {
  var date = time.getDate();
  var month = time.getMonth() + 1;
  var year = time.getFullYear();
  return shippingHolidays.some(function (h) {
    return h[0] === month && h[1] === date && (h[2] === undefined || h[2] === year);
  });
}
function isProcessingHoliday(time) {
  var date = time.getDate();
  var month = time.getMonth() + 1;
  var year = time.getFullYear();
  return processingHolidays.some(function (h) {
    return h[0] === month && h[1] === date && (h[2] === undefined || h[2] === year);
  });
}
function getShippingDate(startTime, nDays) {
  var newStart;
  if (isShippingHoliday(startTime) || startTime.getDay() === 0 || startTime.getDay() === 6) {
    if (startTime.getDay() === 0) {
      if (startTime.getDay() === 0 && isShippingHoliday(startTime.addDays(1))) {
        newStart = startTime.addDays(2);
        newStart.setHours(9);
      } else {
        newStart = startTime.addDays(1);
        newStart.setHours(9);
      }
    } else if (startTime.getDay() === 6) {
      if (startTime.getDay() === 6 && isShippingHoliday(startTime.addDays(2))) {
        newStart = startTime.addDays(3);
        newStart.setHours(9);
      } else {
        newStart = startTime.addDays(2);
        newStart.setHours(9);
      }
    } else {
      newStart = startTime.addDays(1);
      newStart.setHours(9);
    }
  } else {
    newStart = startTime;
  }
  var endTime = newStart;
  var dateString = newStart.toDateString();
  var startDay = newStart.getDay();
  // Check cutoff time
  if (!!shippingCutOffTime[startDay]) {
    var cutOffStart = new Date(dateString + " " + shippingCutOffTime[startDay]);
    if (cutOffStart < endTime) {
  
      nDays++;
    }
  }
  var count = 0;
  while (count < nDays) {
    endTime = endTime.addDays(1);
    var day = endTime.getDay();
    var holiday = isShippingHoliday(endTime);
    if (day === 0 || day === 6 || holiday) {
      continue;
    } else {
      count++;
    }
  }
  return endTime;
}

function getShippingDateChronopost(startTime, nDays) {
  var newStart;
  if (isShippingHoliday(startTime) || startTime.getDay() === 0) {
    if (startTime.getDay() === 0) {
      if (startTime.getDay() === 0 && isShippingHoliday(startTime.addDays(1))) {
        newStart = startTime.addDays(2);
        newStart.setHours(9);
      } else {
        newStart = startTime.addDays(1);
        newStart.setHours(9);
      }
    } else if (startTime.getDay() === 6) {
      if (startTime.getDay() === 6 && isShippingHoliday(startTime.addDays(2))) {
        newStart = startTime.addDays(3);
        newStart.setHours(9);
      } else {
        newStart = startTime.addDays(2);
        newStart.setHours(9);
      }
    } else {
      newStart = startTime.addDays(1);
      newStart.setHours(9);
    }
  } else {
    newStart = startTime;
  }
  var endTime = newStart;
  var dateString = newStart.toDateString();
  var startDay = newStart.getDay();
  // Check cutoff time
  if (!!shippingCutOffTime[startDay]) {
    var cutOffStart = new Date(dateString + " " + shippingCutOffTime[startDay]);
    if (cutOffStart < endTime) {
      nDays++;
    }
  }
  var count = 0;
  while (count < nDays) {
    endTime = endTime.addDays(1);
    var day = endTime.getDay();
    var holiday = isShippingHoliday(endTime);
    if (day === 0 || holiday) {
      continue;
    } else {
      count++;
    }
  }
  return endTime;
}
function getShippingDateColissimo(startTime, nDays) {
  var newStart;
  if (isShippingHoliday(startTime) || startTime.getDay() === 0 || startTime.getDay() === 6) {
    if (startTime.getDay() === 0) {
      if (startTime.getDay() === 0 && isShippingHoliday(startTime.addDays(1))) {
        newStart = startTime.addDays(2);
        newStart.setHours(9);
      } else {
        newStart = startTime.addDays(1);
        newStart.setHours(9);
      }
    } else if (startTime.getDay() === 6) {
      if (startTime.getDay() === 6 && isShippingHoliday(startTime.addDays(2))) {
        newStart = startTime.addDays(3);
        newStart.setHours(9);
      } else {
        newStart = startTime.addDays(2);
        newStart.setHours(9);
      }
    } else {
      newStart = startTime.addDays(1);
      newStart.setHours(9);
    }
  } else {
    newStart = startTime;
  }
  if (startTime.getDay() === 5 && startTime.getHours() >= 13 && isShippingHoliday(startTime.addDays(1))) {
    newStart = startTime.addDays(3);
    newStart.setHours(9);
  }
  var endTime = newStart;
  var dateString = newStart.toDateString();
  var startDay = newStart.getDay();
  // Check cutoff time
  if (!!shippingCutOffTime[startDay]) {
    var cutOffStart = new Date(dateString + " " + shippingCutOffTime[startDay]);
    if (cutOffStart < endTime) {
      if (cutOffStart < endTime && startDay === 5) {
        nDays += 2;
      } else {
        nDays++;
      }
    }
  }
  if (startDay === 6) {
    nDays++;
  }
  if (isShippingHoliday(newStart.addDays(1)) && newStart.addDays(2).getDay() === 6) {
    nDays++;
  }
  var count = 0;
  while (count < nDays) {
    endTime = endTime.addDays(1);
    var day = endTime.getDay();
    var holiday = isShippingHoliday(endTime);
    if (day === 0 || holiday) {
      continue;
    } else {
      count++;
    }
  }
  return endTime;
}
function getShippingDateCollect(startTime, nDays) {
  var newStart;
  if (isShippingHoliday(startTime) || startTime.getDay() === 0 || startTime.getDay() === 6) {
    if (startTime.getDay() === 0) {
      if (startTime.getDay() === 0 && isShippingHoliday(startTime.addDays(1))) {
        newStart = startTime.addDays(2);
        newStart.setHours(9);
      } else {
        newStart = startTime.addDays(1);
        newStart.setHours(9);
      }
    } else if (startTime.getDay() === 6) {
      if (startTime.getDay() === 6 && isShippingHoliday(startTime.addDays(2))) {
        newStart = startTime.addDays(3);
        newStart.setHours(9);
      } else {
        newStart = startTime.addDays(2);
        newStart.setHours(9);
      }
    } else {
      newStart = startTime.addDays(1);
      newStart.setHours(9);
    }
  } else {
    newStart = startTime;
  }
  var endTime = newStart;
  var dateString = newStart.toDateString();
  var startDay = newStart.getDay();
  // Check cutoff time
  if (!!shippingCutOffTime[startDay]) {
    var cutOffStart = new Date(dateString + " " + shippingCutOffTime[startDay]);
    if (cutOffStart < endTime) {
      nDays++;
    }
  }
  var count = 0;
  while (count < nDays) {
    endTime = endTime.addDays(1);
    var day = endTime.getDay();
    var holiday = isShippingHoliday(endTime);
    if (day === 1 || day === 2 || holiday) {
      continue;
    } else {
      count++;
    }
  }
  return endTime;
}
var date = new Date();
/*var date = new Date(2024, 2, 22, 12, 0, 0);*/
var shippingDate = getShippingDateCollect(date);
function formatDate(date) {
  var m_names = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
  var d_names = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
  var actualDate = new Date();
  var tommorow = new Date(actualDate);
  tommorow.setDate(tommorow.addDays(1));
  var myDate = date;
  myDate.setDate(myDate.getDate());
  var curr_date = myDate.getDate();
  var curr_month = myDate.getMonth();
  var curr_day = myDate.getDay();
  if (actualDate.getDate() == curr_date && actualDate.getMonth() == curr_month) {
    return " Aujourd'hui ";
  } else if (tommorow.getDate() == curr_date && tommorow.getMonth() == curr_month) {
    return " Demain ";
  } else {
    return d_names[curr_day] + " " + curr_date + " " + m_names[curr_month];
  }
}
$(window).on('load', function () {
  $(".content-box").each(function (index, value) {
    processRow(value);
  });
});
function processRow(value) {
  var shipping_method = $(value).find(".radio__label__primary").clone() //clone the element
  .children() //select all the children
  .remove() //remove all the children
  .end() //again go back to selected element
  .attr("method").trim(); //trim white space
  var delivery_time = $(value).find(".radio__label__primary > span.small-text").text();
  if (shipping_method == "chronopost") {
    $(value).find(".radio__label__primary.chronopost").append(formatDate(getShippingDateChronopost(date, 1)));
  }
  if (shipping_method == "colissimo") {
    /*$(value).find(".radio__label__primary.colissimo").append(" " + formatDate(getShippingDateColissimo(date, 2))+ " <span style='font-weight:400'>ou</span> " + formatDate(getShippingDateColissimo(date, 3)));*/
    $(value).find(".radio__label__primary.colissimo").append(" " + formatDate(getShippingDateColissimo(date, 2)));
  }
  if (shipping_method == "mondialRelay") {
    $(value).find(".radio__label__primary.mondialRelay").append(formatDate(getShippingDate(date, 3)));
  }
  /*if (shipping_method == "colissimoRelais") {
    $(value).find(".radio__label__primary.colissimoRelais").append( formatDate(getShippingDate(date, 4)));
  }*/
  //  if (shipping_method == "click_collect" ) {
  //     $(value).find(".radio__label__primary.click_collect").html(" " + formatDate(getShippingDateCollect(date, 0)));
  //  }
  //  if (shipping_method == "coursier" ) {
  //   $(value).find(".radio__label__primary.coursier").html(" " + formatDate(getShippingDate(date, 0)));
  //  }
}

var price = $('.available-product--container  .product--price-product').text();
  
$('.value-product-banner').text(price);

$('#continue--shopping').on('click', function () {
  $('.close--container-crossell').click();
});

$('body').on('change', '.product-select-cross', function (e) {

  var option = $(this).find('option:selected');
  //console.log(option)

  var price = option.attr('product-price');
  var available = option.attr('product-available');
  var variant = option.attr('product-variant');
  var product = option.attr('product-id');

  var textButton = 'Ajouter <span class="product-price-cross">' + price + '\u20AC</span>';
  if (available == 'false') {
    textButton = 'Rupture';
  }

  $('.product-button-cross[product-id="' + product + '"]').html(textButton);
  $('.product-button-cross[product-id="' + product + '"]').attr('variant-id', variant);
  $('.product-button-cross[product-id="' + product + '"]').attr('variant-available', available);
});

//Etiquette


$('.title-etiquette').on('click', function () {
  if ($(this).hasClass('opened')) {
    $(this).removeClass('opened');
    $('.content-etiquette').addClass('hide');
    $('.etiquette1 .image-variant').click();
    $('.add__to__cart').removeClass('etiquette');
  } else {
    $(this).addClass('opened');
    $('.content-etiquette').removeClass('hide');
    $('.etiquette2 .image-variant').click();
    $('.add__to__cart').addClass('etiquette');
  }
});

$(document).ready(function () {
  if (productDetails.etiquette == "true") {
    $('.etiquette1 .image-variant').click();

    var nbCharactersTitre = $('.title-etiquette-input').val().length;
    $('.compteur-title').text(nbCharactersTitre);

    $('.title-etiquette-input').on('change keyup', function (e) {
      e.preventDefault();
      nbCharactersTitre = $('.title-etiquette-input').val().length;
      var val = $('.title-etiquette-input').val();

      if (nbCharactersTitre > 20) {
        $('.title-etiquette-input').val(val.substring(0, 20));
        $('.compteur-title--container').addClass('error');
        $('.compteur-title').text("20");
        setTimeout(function () {
          $('.compteur-title--container').removeClass('error');
        }, 600);
      } else {
        $('.compteur-title').text(nbCharactersTitre);
        $('.titre-print').text(val);
      }
    });

    var nbCharactersSousTitre = $('.subtitle-etiquette-input').val().length;
    $('.compteur-title').text(nbCharactersSousTitre);

    $('.subtitle-etiquette-input').on('change keyup', function (e) {
      e.preventDefault();
      nbCharactersSousTitre = $('.subtitle-etiquette-input').val().length;
      var val = $('.subtitle-etiquette-input').val();

      if (nbCharactersSousTitre > 40) {
        $('.subtitle-etiquette-input').val(val.substring(0, 40));
        $('.compteur-subtitle--container').addClass('error');
        $('.compteur-subtitle').text("40");
        setTimeout(function () {
          $('.compteur-subtitle--container').removeClass('error');
        }, 600);
      } else {
        $('.compteur-subtitle').text(nbCharactersSousTitre);
        $('.sous-titre-print').text(val);
      }
    });
  }
});
});